import { n as R } from "./Logger-CmiOOsKC.js";
import { t as ce, v as xe } from "./tracebehavior-5_qSKjs6.js";
import "./boxcollider-DfK5pGI3.js";
import { t as Se } from "./properties-C_pgb9zu.js";
import { a as ze, c as ie, i as Ae, n as Ce, o as ae, r as Fe, s as X, t as Te } from "./LayoutTree-BYNW_PVs.js";
import { Matrix as P, Quaternion as he, Vector3 as m } from "@babylonjs/core/Maths/math.vector.js";
import { Mesh as Ie } from "@babylonjs/core/Meshes/mesh.js";
import { MeshBuilder as Me } from "@babylonjs/core/Meshes/meshBuilder.js";
import "@babylonjs/core/Meshes/Builders/planeBuilder.js";
import { Color3 as J } from "@babylonjs/core/Maths/math.color.js";
import "@babylonjs/core/Meshes/Builders/sphereBuilder.js";
import { Scene as pe } from "@babylonjs/core/scene.js";
import { PBRMaterial as Q } from "@babylonjs/core/Materials/PBR/pbrMaterial.js";
import { GLTF2Export as ue } from "@babylonjs/serializers";
import "@babylonjs/core/Meshes/Builders/boxBuilder.js";
import "@babylonjs/core/Meshes/Builders/cylinderBuilder.js";
var me = /* @__PURE__ */ new Map();
function Be(o) {
  return me.get(o);
}
function st(o) {
  me.set(o.behaviorType, o);
}
var fe = [
  {
    type: "AiSession",
    description: `AiSession behavior data.

Inert: nothing in the runtime reads it, and nothing renders from it. It marks
a node under the editor root whose \`src\` is an AI conversation, a session
file carried as an ordinary data file, so an editor finds its conversations
by type rather than by name or by reading every JSON file in the document.
The node's name is the conversation's title, and the last such node in
document order is the current one.

Editor documents only: a conversation never reaches a viewer, and a host
never puts one in a scene document.`,
    fields: []
  },
  {
    type: "Animation",
    description: "Controls animation playback for objects with Animation components",
    fields: [
      {
        key: "clip",
        type: "string",
        label: "Clip",
        description: "Name of animation clip to play on start",
        optional: !0
      },
      {
        key: "src",
        type: "string",
        label: "Src",
        description: `External animation source GLB path (e.g. "./assets/clips/walk.glb").
When set, loads the clip from this GLB and plays it on the animation root.`,
        optional: !0
      },
      {
        key: "target",
        type: "enum",
        label: "Target",
        options: ["@self", "@vroot"],
        description: `Which node external clip animations target.
- "@self": animate the SceneObject's own transform directly
- "@vroot": animate an intermediate animation root node (keeps the
  SceneObject's logical transform undisturbed)

Only relevant when \`src\` is set (external clips). Defaults to "@vroot"
at runtime when omitted.`,
        optional: !0
      },
      {
        key: "clips",
        type: "array",
        label: "Clips",
        itemFields: [{
          key: "name",
          type: "string",
          label: "Name",
          description: "Animation clip name"
        }, {
          key: "wrap",
          type: "string",
          label: "Wrap",
          description: "Wrap mode for this clip"
        }],
        itemLabel: "Animation Clip Data",
        description: "Array of clip override settings",
        optional: !0
      },
      {
        key: "wrapMode",
        type: "enum",
        label: "Wrap Mode",
        options: [
          "Once",
          "Loop",
          "PingPong",
          "ClampForever"
        ],
        default: "Loop",
        description: "Default wrap mode for animations"
      },
      {
        key: "speed",
        type: "number",
        label: "Speed",
        default: 1,
        step: 0.1,
        description: "Playback speed multiplier"
      },
      {
        key: "playAutomatically",
        type: "boolean",
        label: "Play Automatically",
        default: !0,
        description: "Whether to play automatically on start"
      }
    ]
  },
  {
    type: "AnimationSequence",
    description: `Controls animation sequences with enter/main/exit states.
Animations are applied to the SceneObject's animation root.`,
    fields: [{
      key: "states",
      type: "object",
      label: "States",
      fields: [
        {
          key: "enter",
          type: "object",
          label: "Enter",
          fields: [
            {
              key: "src",
              type: "string",
              label: "Src",
              description: "Source URL or path to the animation GLB file",
              optional: !0
            },
            {
              key: "clip",
              type: "string",
              label: "Clip",
              description: `Animation clip name
Optional; defaults to first clip in GLB`,
              optional: !0
            },
            {
              key: "speed",
              type: "number",
              label: "Speed",
              description: "Animation playback speed (defaults to 1 at runtime)",
              optional: !0
            },
            {
              key: "delay",
              type: "number",
              label: "Delay",
              description: `Delay in seconds before this clip auto-plays (defaults to 0). The
enter clip holds posed at its first frame through the delay — the
building block for staggered entrances; the exit clip's delay offsets
orchestrated departures. The main (looping) slot does not read it.`,
              optional: !0
            }
          ],
          description: "Enter animation state (plays once when object enters)",
          optional: !0
        },
        {
          key: "main",
          type: "object",
          label: "Main",
          fields: [
            {
              key: "src",
              type: "string",
              label: "Src",
              description: "Source URL or path to the animation GLB file",
              optional: !0
            },
            {
              key: "clip",
              type: "string",
              label: "Clip",
              description: `Animation clip name
Optional; defaults to first clip in GLB`,
              optional: !0
            },
            {
              key: "speed",
              type: "number",
              label: "Speed",
              description: "Animation playback speed (defaults to 1 at runtime)",
              optional: !0
            },
            {
              key: "delay",
              type: "number",
              label: "Delay",
              description: `Delay in seconds before this clip auto-plays (defaults to 0). The
enter clip holds posed at its first frame through the delay — the
building block for staggered entrances; the exit clip's delay offsets
orchestrated departures. The main (looping) slot does not read it.`,
              optional: !0
            }
          ],
          description: "Main animation state (loops while object is active)",
          optional: !0
        },
        {
          key: "exit",
          type: "object",
          label: "Exit",
          fields: [
            {
              key: "src",
              type: "string",
              label: "Src",
              description: "Source URL or path to the animation GLB file",
              optional: !0
            },
            {
              key: "clip",
              type: "string",
              label: "Clip",
              description: `Animation clip name
Optional; defaults to first clip in GLB`,
              optional: !0
            },
            {
              key: "speed",
              type: "number",
              label: "Speed",
              description: "Animation playback speed (defaults to 1 at runtime)",
              optional: !0
            },
            {
              key: "delay",
              type: "number",
              label: "Delay",
              description: `Delay in seconds before this clip auto-plays (defaults to 0). The
enter clip holds posed at its first frame through the delay — the
building block for staggered entrances; the exit clip's delay offsets
orchestrated departures. The main (looping) slot does not read it.`,
              optional: !0
            }
          ],
          description: "Exit animation state (plays once when object exits)",
          optional: !0
        }
      ],
      description: "Animation states"
    }]
  },
  {
    type: "AudioClip",
    description: `Standalone audio clip playback. The SceneObject's \`src\` field carries the
media URL (mp3 in v1; any format the browser's HTMLAudioElement decodes
works once added to AUDIO_EXTENSIONS).

Audio plays through the element's default sink by default. Add an
\`AudioSource\` behavior on the same SceneObject to route the audio through
the Web Audio graph for volume, distance attenuation, and 3D positioning.`,
    fields: [
      {
        key: "playOnStart",
        type: "boolean",
        label: "Play On Start",
        default: !0,
        description: "Whether to start playback automatically when the scene enters play mode."
      },
      {
        key: "loop",
        type: "boolean",
        label: "Loop",
        default: !0,
        description: "Whether to loop playback."
      },
      {
        key: "startAt",
        type: "number",
        label: "Start At",
        default: 0,
        step: 1e-3,
        description: "Timeline time, in seconds, at which the clip's first sample sounds\n(after Opus pre-skip). A driving Timeline's `seek(t)` places the media\nat `t − startAt` (clamped at 0); for `t < startAt` the clip is silent\nand starts by itself when the clip's time reaches `startAt` while\nplaying. Negative means the audio began before t = 0, so t = 0 lands\n`−startAt` seconds into the media. The same offset applies without a\nTimeline: the clip's own `play()`/`playOnStart` count from t = 0."
      }
    ],
    actions: [
      {
        name: "play",
        label: "Start playback"
      },
      {
        name: "pause",
        label: "Pause playback"
      },
      {
        name: "stop",
        label: "Stop and rewind to the beginning"
      },
      {
        name: "seek",
        label: 'Seek to a time in seconds. Args: (time, mode?) where mode is "absolute" (default) or "relative".'
      },
      {
        name: "setVolume",
        label: "Set element volume, 0-1 (takes volume argument). For spatial control use AudioSource."
      }
    ]
  },
  {
    type: "AudioSource",
    description: `Spatial audio output. Pairs with a sibling Video or AudioClip behavior on
the same SceneObject and routes the element's audio through the Web Audio
graph for 3D positioning and distance-based volume.`,
    fields: [
      {
        key: "volume",
        type: "number",
        label: "Volume",
        default: 1,
        step: 0.05,
        min: 0,
        max: 1,
        description: "Master volume (0 = silent, 1 = unattenuated)"
      },
      {
        key: "minDistance",
        type: "number",
        label: "Min Distance",
        default: 1,
        step: 0.5,
        min: 0,
        description: "Distance at which volume is at maximum. Inside this radius, no attenuation is applied."
      },
      {
        key: "maxDistance",
        type: "number",
        label: "Max Distance",
        default: 10,
        step: 1,
        min: 0,
        description: "Distance at which volume reaches zero (Linear) or its rolloff floor (Logarithmic)."
      },
      {
        key: "volumeRollOff",
        type: "enum",
        label: "Volume Roll Off",
        options: ["Linear", "Logarithmic"],
        default: "Linear",
        description: "How volume attenuates with distance between min and max."
      },
      {
        key: "spatialBlend",
        type: "number",
        label: "Spatial Blend",
        default: 1,
        step: 0.05,
        min: 0,
        max: 1,
        description: `Mix between 2D (non-spatialized) and 3D (positioned) audio.
0 = pure 2D (full volume regardless of position), 1 = pure 3D (full spatial attenuation).`
      }
    ]
  },
  {
    type: "AutoUI",
    description: `AutoUI automatically discovers Properties and Interactions from child
SceneObjects (including self) and renders them as an interactive UI panel.`,
    fields: [
      {
        key: "renderMode",
        type: "enum",
        label: "Render Mode",
        options: [
          "ScreenSpaceOverlay",
          "ScreenSpaceCamera",
          "WorldSpace"
        ],
        description: `How to render the UI:
- ScreenSpaceOverlay: Full-screen overlay (default)
- ScreenSpaceCamera: Screen-space relative to camera
- WorldSpace: Attached to a 3D plane in the scene`,
        optional: !0
      },
      {
        key: "propertyGroups",
        type: "string",
        label: "Property Groups",
        arrayOf: "string",
        description: `Optional: Specify a parent object by name to discover properties from.
If provided (with a single item), the AutoUI will traverse children of
that object instead of its own children. This supports backwards compatibility.
If not provided, discovers from this object's own children.`,
        optional: !0
      },
      {
        key: "title",
        type: "string",
        label: "Title",
        description: "Panel title (optional)",
        optional: !0
      },
      {
        key: "collapsible",
        type: "boolean",
        label: "Collapsible",
        description: "Let viewers expand/collapse the panel using its title button.",
        optional: !0
      },
      {
        key: "collapseBelowWidth",
        type: "number",
        label: "Collapse Below Width",
        description: "Start collapsed below this CSS viewport width (when collapsible). 0 disables.",
        optional: !0
      },
      {
        key: "collapseOnView",
        type: "boolean",
        label: "Collapse On View",
        description: "Collapse a collapsible inspector after selecting a camera view. Default false.",
        optional: !0
      },
      {
        key: "readout",
        type: "string",
        label: "Readout",
        description: "Read-only explanatory text below the controls. Supports native bindings and newlines.",
        format: "multiline",
        optional: !0
      },
      {
        key: "cameraViews",
        type: "array",
        label: "Camera Views",
        itemFields: [
          {
            key: "label",
            type: "string",
            label: "Label"
          },
          {
            key: "yaw",
            type: "number",
            label: "Yaw",
            step: 0.01,
            default: 0,
            description: "Azimuth in degrees."
          },
          {
            key: "pitch",
            type: "number",
            label: "Pitch",
            step: 0.01,
            default: 0,
            description: "Polar angle from up, degrees (90 = level)."
          },
          {
            key: "target",
            type: "string",
            label: "Target",
            description: `SceneObject path relative to the AutoUI owner. Omit to frame the owner.
An unresolved explicit target leaves the camera unchanged.`
          },
          {
            key: "radiusScale",
            type: "number",
            label: "Radius Scale",
            step: 0.01,
            default: 1.1,
            description: "Padding around the target bounds. Must be finite and >= 1."
          }
        ],
        itemLabel: "Auto U I Camera View",
        description: `Named orbit views of this object's contents. Yaw is azimuth in degrees;
pitch is the polar angle from up (90 = level, 0 = above).
Selecting a view also fits the object's contents in the current viewport.`,
        optional: !0
      },
      {
        key: "width",
        type: "number",
        label: "Width",
        description: "Panel width in pixels (default: 300)",
        optional: !0
      },
      {
        key: "position",
        type: "object",
        label: "Position",
        fields: [{
          key: "x",
          type: "number",
          label: "X"
        }, {
          key: "y",
          type: "number",
          label: "Y"
        }],
        description: "Panel position for ScreenSpace modes (pixels from top-left)",
        optional: !0
      }
    ]
  },
  {
    type: "BehaviorGraph",
    fields: [
      {
        key: "graph",
        type: "object",
        label: "Graph",
        fields: [
          {
            key: "types",
            type: "array",
            label: "Types",
            itemFields: [{
              key: "signature",
              type: "string",
              label: "Signature"
            }],
            itemLabel: "Type Definition",
            default: [],
            description: "Type definitions referenced by index"
          },
          {
            key: "declarations",
            type: "array",
            label: "Declarations",
            itemFields: [{
              key: "op",
              type: "string",
              label: "Op",
              description: 'Namespaced operation type, e.g. "math/add", "trace/setActive"'
            }, {
              key: "extensions",
              type: "string",
              label: "Extensions",
              description: `TRACE_subgraph extension — when present, this declaration's op is
implemented by the referenced subgraph rather than a built-in block.`
            }],
            itemLabel: "Declaration",
            default: [],
            description: "Node operation declarations referenced by index"
          },
          {
            key: "variables",
            type: "array",
            label: "Variables",
            itemFields: [
              {
                key: "name",
                type: "string",
                label: "Name",
                description: "Variable name (for editor UI — resolution is by index)"
              },
              {
                key: "type",
                type: "number",
                label: "Type",
                step: 0.01,
                default: 0,
                description: "Index into types[]"
              },
              {
                key: "value",
                type: "string",
                label: "Value",
                arrayOf: "unknown",
                default: [],
                description: "Initial value as flat component array"
              }
            ],
            itemLabel: "Graph Variable",
            default: [],
            description: "Graph-scoped mutable variables"
          },
          {
            key: "events",
            type: "array",
            label: "Events",
            itemFields: [{
              key: "id",
              type: "string",
              label: "Id",
              description: "External event identifier. Empty string = an INTERNAL event (the KHR\nspec's event without an `id`): it only links `event/send` to\n`event/receive` nodes of the same graph — the way repetition (e.g. the\nInterval macro) re-enters an acyclic graph. Nodes address events by\nINDEX (`configuration.event`), never by id."
            }, {
              key: "values",
              type: "string",
              label: "Values",
              description: "Optional typed parameters"
            }],
            itemLabel: "Graph Event",
            default: [],
            description: "Custom event definitions"
          },
          {
            key: "nodes",
            type: "array",
            label: "Nodes",
            itemFields: [
              {
                key: "declaration",
                type: "number",
                label: "Declaration",
                step: 0.01,
                default: 0,
                description: "Index into declarations[]"
              },
              {
                key: "configuration",
                type: "string",
                label: "Configuration",
                description: "Static configuration (target paths, clip names, variable indices)"
              },
              {
                key: "values",
                type: "string",
                label: "Values",
                description: "Value input sockets — data dependencies"
              },
              {
                key: "flows",
                type: "string",
                label: "Flows",
                description: "Flow output sockets — execution routing"
              },
              {
                key: "metadata",
                type: "string",
                label: "Metadata",
                description: "Editor metadata (position, etc.) — ignored by runtime"
              }
            ],
            itemLabel: "Graph Node",
            default: [],
            description: "The nodes"
          },
          {
            key: "inputFlowSockets",
            type: "object",
            label: "Input Flow Sockets",
            fields: [{
              key: "node",
              type: "number",
              label: "Node"
            }, {
              key: "socket",
              type: "string",
              label: "Socket"
            }],
            isMap: !0,
            description: "Named flow entry points — maps socket name → internal node+socket",
            optional: !0
          },
          {
            key: "outputFlowSockets",
            type: "object",
            label: "Output Flow Sockets",
            fields: [{
              key: "node",
              type: "number",
              label: "Node"
            }, {
              key: "socket",
              type: "string",
              label: "Socket"
            }],
            isMap: !0,
            description: "Named flow exit points — maps socket name → internal node+socket",
            optional: !0
          },
          {
            key: "inputValueSockets",
            type: "object",
            label: "Input Value Sockets",
            fields: [
              {
                key: "type",
                type: "number",
                label: "Type",
                description: "Index into this graph's types[] array"
              },
              {
                key: "node",
                type: "number",
                label: "Node",
                description: "Internal node index that consumes this input (editor only)",
                optional: !0
              },
              {
                key: "socket",
                type: "string",
                label: "Socket",
                description: "Socket name on the internal node (editor only, defaults to the socket key name)",
                optional: !0
              },
              {
                key: "description",
                type: "string",
                label: "Description",
                description: "Human-readable description (editor only)",
                optional: !0
              }
            ],
            isMap: !0,
            description: "Named value inputs with types — the parent supplies these",
            optional: !0
          },
          {
            key: "outputValueSockets",
            type: "object",
            label: "Output Value Sockets",
            fields: [
              {
                key: "node",
                type: "number",
                label: "Node",
                description: "Internal node index that produces this output"
              },
              {
                key: "socket",
                type: "string",
                label: "Socket",
                description: "Socket name on the internal node"
              },
              {
                key: "type",
                type: "number",
                label: "Type",
                description: "Index into this graph's types[] array"
              },
              {
                key: "description",
                type: "string",
                label: "Description",
                description: "Human-readable description (editor only)",
                optional: !0
              }
            ],
            isMap: !0,
            description: "Named value outputs — points to internal node+socket that produces the value",
            optional: !0
          }
        ],
        default: {
          types: [],
          declarations: [],
          variables: [],
          events: [],
          nodes: []
        },
        description: "The behavior graph definition (single-graph mode, backward compat).\nWhen `graphs` is present, this field is ignored."
      },
      {
        key: "graphs",
        type: "array",
        label: "Graphs",
        itemFields: [
          {
            key: "types",
            type: "string",
            label: "Types",
            arrayOf: '{ signature: "string" | "bool" | "int" | "float" | "float2" | "float3" | "float4" | "float2x2" | "float3x3" | "float4x4" | "color" }',
            default: [],
            description: "Type definitions referenced by index"
          },
          {
            key: "declarations",
            type: "string",
            label: "Declarations",
            arrayOf: "{ op: string; extensions?: object }",
            default: [],
            description: "Node operation declarations referenced by index"
          },
          {
            key: "variables",
            type: "string",
            label: "Variables",
            arrayOf: "{ name: string; type: number; value: unknown[] }",
            default: [],
            description: "Graph-scoped mutable variables"
          },
          {
            key: "events",
            type: "string",
            label: "Events",
            arrayOf: "{ id: string; values?: object }",
            default: [],
            description: "Custom event definitions"
          },
          {
            key: "nodes",
            type: "string",
            label: "Nodes",
            arrayOf: "{ declaration: number; configuration?: object; values?: object; flows?: object; metadata?: object }",
            default: [],
            description: "The nodes"
          },
          {
            key: "inputFlowSockets",
            type: "string",
            label: "Input Flow Sockets",
            description: "Named flow entry points — maps socket name → internal node+socket"
          },
          {
            key: "outputFlowSockets",
            type: "string",
            label: "Output Flow Sockets",
            description: "Named flow exit points — maps socket name → internal node+socket"
          },
          {
            key: "inputValueSockets",
            type: "string",
            label: "Input Value Sockets",
            description: "Named value inputs with types — the parent supplies these"
          },
          {
            key: "outputValueSockets",
            type: "string",
            label: "Output Value Sockets",
            description: "Named value outputs — points to internal node+socket that produces the value"
          }
        ],
        itemLabel: "Graph Data",
        description: "Multiple graph definitions (TRACE_subgraph mode).\ngraphs[0] is typically the main graph; other entries are subgraph definitions.\nThe active (entry-point) graph index is specified by `activeGraph`.",
        optional: !0
      },
      {
        key: "activeGraph",
        type: "number",
        label: "Active Graph",
        default: 0,
        description: "Index into `graphs[]` for the entry-point graph. Defaults to 0."
      }
    ]
  },
  {
    type: "Bevel",
    description: `Rounds the corners of the node's primitive.

A geometry modifier, not a shape: it regenerates the node's cube or
plane primitive with its four corners filleted (the RealityKit
\`generateBox(cornerRadius:)\` analog, applied Blender-modifier-style).
Corner arcs are aspect-compensated against the node's scale, so radii
stay circular however the slab is stretched. Flat hosts (planes) stay
flat; slabs keep their thickness.

\`cornerRadius\` is in METERS, the unit the solver hands out and the same
one MeshBackground, Image and Video use (#759). CSS-pixel semantics: a
resized slab keeps its corner SIZE rather than its corner proportion.
\`pill\` asks for half the current smaller side instead — "a capsule,
whatever size the solver picks" — which is the one thing an absolute
radius cannot say. The radius clamps to half the smaller side at render,
so an oversized value degrades to a pill rather than self-crossing.

Strictly geometry: paint stays on Renderer, sizing stays on the
transform. Clients without a Bevel implementation render the sharp
primitive — content intact, corners square.`,
    fields: [
      {
        key: "cornerRadius",
        type: "number",
        label: "Corner Radius",
        default: 0,
        step: 1e-3,
        min: 0,
        description: "Corner radius in meters. Clamped to half the smaller side at render."
      },
      {
        key: "pill",
        type: "boolean",
        label: "Pill",
        default: !1,
        description: "Round the corners to half the current smaller side — a capsule at any\nsize. Overrides `cornerRadius` when true."
      },
      {
        key: "axis",
        type: "enum",
        label: "Axis",
        options: [
          "auto",
          "x",
          "y",
          "z"
        ],
        default: "auto",
        description: `Extrusion axis — corners are rounded in the perpendicular plane.
"auto" picks the slab's thinnest world axis (its natural thickness);
flat hosts (planes) always round in their own plane.`
      },
      {
        key: "edges",
        type: "enum",
        label: "Edges",
        options: ["corners", "all"],
        default: "corners",
        description: `Which edges to round. "corners" fillets the four side edges only;
"all" also rounds the rim where the walls meet the faces (a fully
filleted box — rim radius is the corner radius clamped to half the
thickness, so thin slabs get a soft pill edge). Ignored on flat hosts.`
      }
    ]
  },
  {
    type: "Billboard",
    description: "Makes an object always face the camera",
    fields: [
      {
        key: "enabled",
        type: "boolean",
        label: "Enabled",
        default: !0,
        description: `Whether facing is active when play mode starts. When false the object
sits at its authored rotation until the behavior graph enables it
(trace/setBehaviorEnabled). Disabling at runtime applies \`onExit\`
(ease back or hold); every play-mode start resets to this value.`
      },
      {
        key: "axes",
        type: "multiSelect",
        label: "Axes",
        options: [
          "x",
          "y",
          "z"
        ],
        default: [
          "x",
          "y",
          "z"
        ],
        description: `Rotation axes that track the camera. "y" enables turning (yaw),
"x" enables tilting (pitch); "z" (banking) must be ignored by
implementations. Omitted = all axes (the classic full billboard).`
      },
      {
        key: "influence",
        type: "number",
        label: "Influence",
        default: 1,
        description: `How completely the object turns toward the camera, 0-1.
1 faces dead-on; lower values make a partial, more lifelike turn.`
      },
      {
        key: "damping",
        type: "number",
        label: "Damping",
        default: 0,
        description: `Turning lag as a time constant in seconds — larger trails the camera
more softly. 0 snaps instantly (the classic billboard).`
      },
      {
        key: "viewAngle",
        type: "number",
        label: "View Angle",
        default: 0,
        description: "Engagement cone half-angle in degrees, measured from the authored\nresting direction: the object tracks the camera only while the camera\nsits within `viewAngle` degrees of the rest forward (full cone apex\nangle = 2 × viewAngle). Outside it, tracking disengages and `onExit`\napplies. 0 = unlimited (always track); values >= 180 also mean\nunlimited (the cone covers everything). Same name and unit as\nViewAnchor's `viewAngle`."
      },
      {
        key: "onExit",
        type: "enum",
        label: "On Exit",
        options: ["return", "hold"],
        default: "return",
        description: `What happens when the camera leaves the view cone: ease back to the
authored rotation ("return") or keep the last orientation ("hold").`
      },
      {
        key: "reverse",
        type: "boolean",
        label: "Reverse",
        default: !1,
        description: "When true, the object faces away from the camera instead of toward it."
      },
      {
        key: "minDistance",
        type: "number",
        label: "Min Distance",
        default: 0,
        description: `Minimum distance from the camera at which the billboard effect is active.
Below this distance the billboard orientation is frozen.`
      }
    ]
  },
  {
    type: "BoxCollider",
    description: "Box-shaped collider for physics and interaction detection",
    fields: [{
      key: "size",
      type: "vec3",
      label: "Size",
      description: `Size of the box collider in local space.
When omitted, derived from model bounding box if present, else from the
selection box of a meshless object such as Text (at least 5 cm deep), otherwise 1x1x1.`,
      optional: !0
    }, {
      key: "center",
      type: "vec3",
      label: "Center",
      description: `Center offset of the collider relative to the transform.
When omitted, derived from the center of that bounding box if present, otherwise origin.`,
      optional: !0
    }]
  },
  {
    type: "ContentSlot",
    description: `Fits the container's single child to the container's width and height.

Only width and height constrain the fit; depth never does. The container's
depth should Hug, so it follows the fitted content and the stack around it
re-solves. The content root must Hug (or be Fixed) on its own axes — its
scale-1 box is what the fit divides the slot by.`,
    fields: [{
      key: "fit",
      type: "enum",
      label: "Fit",
      options: [
        "contain",
        "scale-down",
        "none"
      ],
      default: "contain",
      description: "How the content meets the slot."
    }, {
      key: "zooms",
      type: "string",
      label: "Zooms",
      arrayOf: "number",
      description: "Discrete scale steps. The fit takes the largest step that fits both\nwidth and height (and, under `scale-down`, is at most 1); when none\ndoes, it takes the continuous ratio. Absent or empty means continuous.",
      optional: !0
    }]
  },
  {
    type: "Frame",
    description: "Adds a customizable frame around images or other content",
    fields: [
      {
        key: "borderWidth",
        type: "number",
        label: "Border Width",
        default: 3,
        step: 1,
        description: "Width of frame border in pixels"
      },
      {
        key: "color",
        type: "color",
        label: "Color",
        default: "#FFD700",
        description: `Frame color in hex format
Examples: "#FFD700", "#FF0000AA"`
      },
      {
        key: "src",
        type: "string",
        label: "Src",
        description: `Path to custom frame GLB model
When provided, uses custom 3D frame instead of generated frame`,
        optional: !0
      }
    ]
  },
  {
    type: "Image",
    description: "Controls image display settings",
    fields: [
      {
        key: "aspect",
        type: "number",
        label: "Aspect",
        step: 0.01,
        description: `Image aspect ratio (width/height).

Absent means UNKNOWN, not square. It used to default to 1, so every
image node was born claiming to be square — a claim made before anything
had looked at the image, yet strong enough to letterbox a landscape node
down to a square plane when the texture never arrived. Matches Video,
where the field has always been optional and undefined means "nobody has
measured this yet".`,
        optional: !0
      },
      {
        key: "orientation",
        type: "enum",
        label: "Orientation",
        options: ["Horizontal", "Vertical"],
        default: "Vertical",
        description: "Image orientation"
      },
      {
        key: "fit",
        type: "enum",
        label: "Fit",
        options: ["contain", "cover"],
        default: "contain",
        description: `How the image meets a box whose aspect differs from its own.

\`contain\` (the default) letterboxes: the plane shrinks on one axis so
the whole image stays visible inside the box, never distorted.

\`cover\` fills: the plane spans the box exactly and a centered window
of the image is shown instead, cropping the overflowing axis. The
crop is a view, not an edit — switching back to \`contain\` shows the
full image again.

Absent means \`contain\`: exactly the fit scenes have always had.`
      },
      {
        key: "cornerRadius",
        type: "number",
        label: "Corner Radius",
        default: 0,
        step: 1e-3,
        min: 0,
        description: `Corner radius in meters (the unit MeshBackground's cornerRadius
uses; measured here on the CURRENT visible media rectangle - a
media quad has no rest box). One value gives differently sized
frames identical corners, and a resized frame keeps its corner
size. Never larger than half the rectangle's current smaller side
- an oversized value degrades to a pill instead of self-crossing.

Rounds the media quad itself, which neither Bevel (its host gate
takes only builtin primitives) nor MeshBackground (drives the
library rigs' authored morphs) can reach. Composes with \`fit\`: the
corners round the letterboxed rectangle under \`contain\`, the full
box under \`cover\`. Strictly geometry: paint stays on Renderer,
sizing stays on the transform; clients without a corner-radius
implementation render the sharp rectangle - content intact.`
      },
      {
        key: "pill",
        type: "boolean",
        label: "Pill",
        default: !1,
        description: `Round the quad to half its smaller side — a capsule at any size,
which is the one shape an absolute radius cannot name. Overrides
\`cornerRadius\` when true. Same vocabulary as Bevel and
MeshBackground (#759).`
      },
      {
        key: "back",
        type: "enum",
        label: "Back",
        options: [
          "none",
          "picture",
          "color"
        ],
        default: "none",
        description: "What the quad's back shows. `none` culls it: nothing is drawn behind\nthe picture. `picture` renders the media on both faces of the one\nquad - seen from behind it reads mirrored, as a print does through\nits paper (a two-sided quad; glTF's doubleSided idea, NOT a second\nreadable surface). `color` backs the picture with a flat unlit\n`backColor` card that also shows through transparent pixels from the\nfront. A GLB export carries what the object shows: `picture` as the\ndoubled quad, `color` as a second mesh named `<quad>_back`."
      },
      {
        key: "backColor",
        type: "color",
        label: "Back Color",
        default: "#FFFFFF",
        description: "The card color behind the picture when `back` is `color`\n(#RRGGBB or #RRGGBBAA - the alpha rides the string). Ignored for\nthe other values."
      }
    ]
  },
  {
    type: "ImageAnchor",
    description: `Describes an image-marker anchor for a scene.

Attached to the scene root in editor mode as a UI affordance: it renders a
preview of the printed marker (textured plane at physical scale) and lets
the author edit the marker's expected orientation. Source-of-truth for the
marker URL and physical width currently lives on the CMS Scene record;
this behavior is CMS-managed and is excluded from \`.trace\` export. It
round-trips through the publish-metadata channel.`,
    fields: [
      {
        key: "src",
        type: "string",
        label: "Src",
        description: "URL of the marker image asset.",
        optional: !0
      },
      {
        key: "widthMeters",
        type: "number",
        label: "Width Meters",
        default: 0.2,
        step: 0.01,
        description: "Physical width of the printed marker in meters."
      },
      {
        key: "orientation",
        type: "enum",
        label: "Orientation",
        options: [
          "Horizontal",
          "Vertical",
          "Free"
        ],
        default: "Free",
        description: "Expected marker orientation in the world.\n`Free` means the runtime accepts any detected pose."
      },
      {
        key: "pitchDegrees",
        type: "number",
        label: "Pitch Degrees",
        default: 0,
        step: 1,
        description: "Pitch of the marker in degrees, about the marker's local X axis\n(image-right). Positive values tilt the marker's top edge away\nfrom the viewer.\n\n`orientation` and `pitchDegrees` describe the same pose at\ndifferent fidelities — `pitchDegrees` is the full angle, while\n`orientation` is a semantic label (Wall / Floor / Free). When\n`orientation` is `Vertical` or `Horizontal` it gives the complete\npose and `pitchDegrees` is ignored. When `orientation` is `Free`\nor unset, `pitchDegrees` provides the absolute angle."
      }
    ]
  },
  {
    type: "Keyframes",
    description: `Keyframes behavior — named subtree configurations with transitions.

Attach to a container object. Each keyframe describes what its subtree
should look like when active. The runtime pushes each entry as a state
contribution onto the target descendant's \`Properties\` resolver — the
resolver then handles interpolation, cascade, active toggling, and
\`enterFrom\` snap.

Target paths must have a \`Properties\` behavior attached to receive
contributions; entries on bare nodes are skipped with a warning.`,
    fields: [
      {
        key: "keyframes",
        type: "object",
        label: "Keyframes",
        fields: [{
          key: "transition",
          type: "object",
          label: "Transition",
          fields: [
            {
              key: "duration",
              type: "number",
              label: "Duration",
              min: 0,
              description: "Transition duration in seconds"
            },
            {
              key: "easing",
              type: "enum",
              label: "Easing",
              options: [
                "linear",
                "easeIn",
                "easeOut",
                "easeInOut",
                "snap",
                "back",
                "anticipate"
              ],
              default: "easeInOut",
              description: "Easing function"
            },
            {
              key: "delay",
              type: "number",
              label: "Delay",
              default: 0,
              min: 0,
              description: "Delay before transition starts, in seconds"
            }
          ],
          default: {
            duration: 0.5,
            easing: "easeInOut"
          },
          description: `Default transition when navigating TO this keyframe.
Per-entry transitions override this.`
        }, {
          key: "entries",
          type: "object",
          label: "Entries",
          fields: [
            {
              key: "transform",
              type: "object",
              label: "Transform",
              fields: [
                {
                  key: "position",
                  type: "vec3",
                  label: "Position",
                  description: "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
                  optional: !0
                },
                {
                  key: "rotation",
                  type: "vec4",
                  label: "Rotation",
                  description: "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
                  optional: !0
                },
                {
                  key: "scale",
                  type: "vec3",
                  label: "Scale",
                  description: "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
                  optional: !0
                }
              ],
              description: "Absolute local pose for this keyframe. Same semantics as\n`StateDefinition.transform` — replaces per component, omit → authored.",
              optional: !0
            },
            {
              key: "values",
              type: "object",
              label: "Values",
              fields: [],
              isMap: !0,
              description: `Property value overrides. Keyed by property name.
Values are PropertyValue: string | number | boolean | [n,n,n] | [n,n,n,n].
Omitted properties keep their resolved value.`,
              optional: !0
            },
            {
              key: "active",
              type: "boolean",
              label: "Active",
              description: "Visibility override. Omitted means no change from authored base.",
              optional: !0
            },
            {
              key: "transition",
              type: "object",
              label: "Transition",
              fields: [
                {
                  key: "duration",
                  type: "number",
                  label: "Duration",
                  min: 0,
                  description: "Transition duration in seconds"
                },
                {
                  key: "easing",
                  type: "enum",
                  label: "Easing",
                  options: [
                    "linear",
                    "easeIn",
                    "easeOut",
                    "easeInOut",
                    "snap",
                    "back",
                    "anticipate"
                  ],
                  default: "easeInOut",
                  description: "Easing function"
                },
                {
                  key: "delay",
                  type: "number",
                  label: "Delay",
                  default: 0,
                  min: 0,
                  description: "Delay before transition starts, in seconds"
                }
              ],
              description: `Per-entry transition override for stagger / per-child timing.
If omitted, uses the keyframe-level transition, then the behavior-level default.`,
              optional: !0
            },
            {
              key: "enterFrom",
              type: "object",
              label: "Enter From",
              fields: [
                {
                  key: "position",
                  type: "vec3",
                  label: "Position",
                  description: "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
                  optional: !0
                },
                {
                  key: "rotation",
                  type: "vec4",
                  label: "Rotation",
                  description: "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
                  optional: !0
                },
                {
                  key: "scale",
                  type: "vec3",
                  label: "Scale",
                  description: "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
                  optional: !0
                }
              ],
              description: "Entry pose for objects becoming active (`active:false → true`). The runtime\nsnaps to this absolute local pose (omitted fields fall back to the keyframe\npose) and animates to the keyframe pose. Same absolute semantics as `transform`.",
              optional: !0
            }
          ],
          isMap: !0,
          description: `Sparse object overrides, keyed by TransformPath relative to the container.

\`"./"\` targets the container itself (for inherited property values).
\`"./Page1/Car"\` targets a descendant.

Objects not listed keep their authored configuration.
Objects listed in the previous keyframe but not this one revert to authored base.`
        }],
        isMap: !0,
        description: "Named keyframes. Keys are keyframe names."
      },
      {
        key: "initialKeyframe",
        type: "string",
        label: "Initial Keyframe",
        description: `The initially active keyframe (by name).
If omitted, the scene starts at authored base (no keyframe active).`,
        optional: !0
      },
      {
        key: "transitionDuration",
        type: "number",
        label: "Transition Duration",
        default: 0.5,
        min: 0,
        description: "Default transition duration when a keyframe doesn't specify one."
      },
      {
        key: "transitionEasing",
        type: "enum",
        label: "Transition Easing",
        options: [
          "linear",
          "easeIn",
          "easeOut",
          "easeInOut",
          "snap",
          "back",
          "anticipate"
        ],
        default: "easeInOut",
        description: "Default transition easing when a keyframe doesn't specify one."
      }
    ],
    actions: [
      {
        name: "goTo",
        label: "Navigate to a named keyframe"
      },
      {
        name: "next",
        label: "Next keyframe"
      },
      {
        name: "prev",
        label: "Previous keyframe"
      }
    ]
  },
  {
    type: "Layout",
    description: `3D flexbox auto-layout container. Children flow along the \`direction\` axis
(the main axis), like a flexbox row/column extended into 3D. All lengths
are meters.

Mental model — CSS/Figma mapping:
- \`direction\` ≈ flex-direction (X = row, Y = column top-down, Z = depth stack running
  away from the camera: the first child sits on the front face, each later one behind it)
- \`alignMain\` ≈ justify-content, \`alignCross\` ≈ align-items
- Sizing modes per axis: Fixed = explicit size, Hug ≈ fit-content, Fill ≈ flex: 1

A Layout node is both a container for its children and an item in its
parent's layout — item fields (sizing, flex, position) are inherited from
LayoutItemInput.

How children participate:
- Child with Layout or LayoutItem: fully managed — layout writes its
  position, and (for leaves) its scale from the resolved size.
- Plain child (neither behavior): positioned but never resized; its current
  scale magnitude is read as a Fixed size. Consequence: a model moves into
  place but keeps its own scale.
- \`positionMode: "Absolute"\`: removed from flow — keeps its own transform
  position; Fill/percent sizing still resolves against this container.

Cross-axis note: \`alignCross\` controls the first cross axis (e.g. X for a
Y-column); the second cross axis (depth) defaults to Center and is
authorable via \`alignCrossB\`. A single child overrides either for itself
with \`alignSelfCross\`/\`alignSelfCrossB\` (CSS \`align-self\`); unset inherits
and keeps following the container, which repeating the container's value
does not. Layout solves from
the topmost ancestor with a Layout behavior and recurses through plain
grouping nodes. Results are applied asynchronously (microtask) after commit.`,
    fields: [
      {
        key: "direction",
        type: "enum",
        label: "Direction",
        options: [
          "X",
          "Y",
          "Z"
        ],
        default: "Y",
        description: 'Main axis direction for child flow.\nX = horizontal row, Y = vertical column, Z = depth stack, front to back\n(the first child is nearest the camera; `alignMain: "Start"` and `padding.front`\nname the camera-facing face).',
        group: "Container"
      },
      {
        key: "gap",
        type: "number",
        label: "Gap",
        default: 0.02,
        step: 0.01,
        min: 0,
        description: "Space between children in meters.",
        group: "Container"
      },
      {
        key: "padding",
        type: "number",
        label: "Padding",
        objectFields: [
          {
            key: "left",
            type: "number",
            label: "Left",
            default: 0,
            step: 0.01,
            min: 0
          },
          {
            key: "right",
            type: "number",
            label: "Right",
            default: 0,
            step: 0.01,
            min: 0
          },
          {
            key: "top",
            type: "number",
            label: "Top",
            default: 0,
            step: 0.01,
            min: 0
          },
          {
            key: "bottom",
            type: "number",
            label: "Bottom",
            default: 0,
            step: 0.01,
            min: 0
          },
          {
            key: "front",
            type: "number",
            label: "Front",
            default: 0,
            step: 0.01,
            min: 0
          },
          {
            key: "back",
            type: "number",
            label: "Back",
            default: 0,
            step: 0.01,
            min: 0
          }
        ],
        default: 0.02,
        step: 0.01,
        min: 0,
        description: `Internal padding in meters. Number for uniform (all six sides), object
for per-side (left/right/top/bottom/front/back — omitted sides are 0).`,
        group: "Container"
      },
      {
        key: "alignMain",
        type: "enum",
        label: "Align Main",
        options: [
          "Start",
          "Center",
          "End",
          "SpaceBetween",
          "SpaceAround",
          "SpaceEvenly"
        ],
        default: "Start",
        description: "How children are distributed along the main axis.",
        group: "Container"
      },
      {
        key: "alignCross",
        type: "enum",
        label: "Align Cross",
        options: [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        default: "Start",
        description: "How children are aligned on the first cross axis (the second cross\naxis is controlled by `alignCrossB`). Stretch expands non-Fixed\nchildren to fill it.",
        group: "Container"
      },
      {
        key: "alignCrossB",
        type: "enum",
        label: "Align Cross B",
        options: [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        default: "Center",
        description: `How children are aligned on the SECOND cross axis — depth for X/Y
direction containers (Figma's Front/Center/Back). Stretch expands
non-Fixed children to fill it.`,
        group: "Container"
      },
      {
        key: "crossGap",
        type: "number",
        label: "Cross Gap",
        step: 0.01,
        min: 0,
        description: "Spacing in meters between wrapped lines/layers on the cross axes.\nFalls back to `gap` when absent.",
        group: "Container",
        optional: !0
      },
      {
        key: "wrap",
        type: "boolean",
        label: "Wrap",
        default: !1,
        description: `Wrap children to the next line when they overflow the main axis.
When false, children shrink per flexShrink and may overflow.`,
        group: "Container"
      },
      {
        key: "wrapAxis",
        type: "enum",
        label: "Wrap Axis",
        options: [
          "X",
          "Y",
          "Z"
        ],
        description: "Which axis wrapped lines stack along — one of the two cross axes.\nOnly meaningful when `wrap` is true. Cross-axis ROLES follow it:\n`alignCross`, `alignContent`, and `crossGap` apply along the chosen\naxis, `alignCrossB`/`alignContentCrossB` along the other — the same\nrole re-mapping `direction` already performs. Must differ from\n`direction`; absent or invalid falls back to the implicit first\ncross axis, so existing scenes are unchanged.",
        group: "Container",
        optional: !0
      },
      {
        key: "alignContent",
        type: "enum",
        label: "Align Content",
        options: [
          "Start",
          "Center",
          "End",
          "SpaceBetween",
          "SpaceAround",
          "SpaceEvenly"
        ],
        default: "Start",
        description: "How wrapped LINES are distributed along the first cross axis — the\nwrap counterpart of `alignMain` (CSS align-content). Ignored unless\n`wrap` is true.",
        group: "Container"
      },
      {
        key: "alignContentCrossB",
        type: "enum",
        label: "Align Content Cross B",
        options: [
          "Start",
          "Center",
          "End",
          "SpaceBetween",
          "SpaceAround",
          "SpaceEvenly"
        ],
        default: "Start",
        description: "How wrapped LAYERS are distributed along the second cross axis when\nlines overflow into it. Ignored unless `wrap` is true.",
        group: "Container"
      },
      {
        key: "width",
        type: "number",
        label: "Width",
        default: 1,
        step: 0.01,
        min: 0,
        description: "Explicit width in meters.",
        group: "Sizing"
      },
      {
        key: "height",
        type: "number",
        label: "Height",
        default: 1,
        step: 0.01,
        min: 0,
        description: "Explicit height in meters.",
        group: "Sizing"
      },
      {
        key: "depth",
        type: "number",
        label: "Depth",
        default: 1,
        step: 0.01,
        min: 0,
        description: "Explicit depth in meters.",
        group: "Sizing"
      },
      {
        key: "widthMode",
        type: "enum",
        label: "Width Mode",
        options: [
          "Fixed",
          "Hug",
          "Fill"
        ],
        default: "Fixed",
        description: `How width is determined.
Fixed = use explicit width, Hug = shrink to content, Fill = expand to parent.`,
        group: "Sizing"
      },
      {
        key: "heightMode",
        type: "enum",
        label: "Height Mode",
        options: [
          "Fixed",
          "Hug",
          "Fill"
        ],
        default: "Fixed",
        description: "How height is determined.",
        group: "Sizing"
      },
      {
        key: "depthMode",
        type: "enum",
        label: "Depth Mode",
        options: [
          "Fixed",
          "Hug",
          "Fill"
        ],
        default: "Fixed",
        description: "How depth is determined.",
        group: "Sizing"
      },
      {
        key: "minWidth",
        type: "number",
        label: "Min Width",
        step: 0.01,
        min: 0,
        description: `Minimum width in meters — a floor for Fill/shrink resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "maxWidth",
        type: "number",
        label: "Max Width",
        step: 0.01,
        min: 0,
        description: `Maximum width in meters — a size ceiling, including wrapping for Hug Text.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "minHeight",
        type: "number",
        label: "Min Height",
        step: 0.01,
        min: 0,
        description: `Minimum height in meters — a floor for Fill/shrink resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "maxHeight",
        type: "number",
        label: "Max Height",
        step: 0.01,
        min: 0,
        description: `Maximum height in meters — a ceiling for Fill/grow resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "minDepth",
        type: "number",
        label: "Min Depth",
        step: 0.01,
        min: 0,
        description: `Minimum depth in meters — a floor for Fill/shrink resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "maxDepth",
        type: "number",
        label: "Max Depth",
        step: 0.01,
        min: 0,
        description: `Maximum depth in meters — a ceiling for Fill/grow resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "flexGrow",
        type: "number",
        label: "Flex Grow",
        default: 0,
        step: 0.1,
        min: 0,
        description: `Growth weight along the main axis when the container has free space.
0 = auto: Fill children grow with weight 1, Fixed/Hug children don't.
Set > 0 to weight growth among siblings (like CSS flex-grow).`,
        group: "Flex"
      },
      {
        key: "flexShrink",
        type: "number",
        label: "Flex Shrink",
        default: 1,
        step: 0.1,
        min: 0,
        description: "Flex shrink factor.",
        group: "Flex"
      },
      {
        key: "positionMode",
        type: "enum",
        label: "Position Mode",
        options: ["Auto", "Absolute"],
        default: "Auto",
        description: `Position mode. Auto = arranged by the layout flow.
Absolute = removed from flow: the object keeps its own transform
position, but Fill/percent sizing still resolves against the parent.`,
        group: "Position"
      },
      {
        key: "inset",
        type: "object",
        label: "Inset",
        fields: [{
          key: "left",
          type: "number",
          label: "Left",
          step: 0.01,
          min: 0,
          description: "Distance from the containing box's left edge to the child's left edge.",
          optional: !0
        }, {
          key: "top",
          type: "number",
          label: "Top",
          step: 0.01,
          min: 0,
          description: "Distance from the containing box's top edge to the child's top edge.",
          optional: !0
        }],
        description: `Top-left offset for an Absolute child, in meters, from the containing
box's corner to this child's own corner — CSS \`left\`/\`top\`. Read only
when \`positionMode\` is Absolute; ignored on a flow child, which takes
its position from the flow.

It exists because a corner is the only placement an author can state
ahead of the solve. The transform an Absolute child otherwise keeps is
CENTRE-based, and converting corner to centre needs the containing size
AND the child's own size — neither of which exists until layout runs,
so anything upstream that converts early has to guess both and is wrong
by half the difference whenever either extent is Hug or Fill. The
solver holds both numbers at the moment it places the child.`,
        group: "Position",
        optional: !0
      },
      {
        key: "alignSelfCross",
        type: "enum",
        label: "Align Self Cross",
        options: [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        description: `This item's own alignment on the container's FIRST cross axis,
overriding the container's \`alignCross\` for this child alone — CSS
\`align-self\`. Stretch fills the cross extent.

Unset inherits from the container, which is not the same statement as
setting the container's value explicitly: an inherited value follows the
container when it changes, an authored one does not.`,
        group: "Alignment",
        optional: !0
      },
      {
        key: "alignSelfCrossB",
        type: "enum",
        label: "Align Self Cross B",
        options: [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        description: `This item's own alignment on the container's SECOND cross axis,
overriding \`alignCrossB\` for this child alone. In a vertical container
that is the depth axis, which is how a single card sits proud of the
stack it flows in.

Unset inherits from the container.`,
        group: "Alignment",
        optional: !0
      }
    ]
  },
  {
    type: "LayoutItem",
    description: `Layout item sizing behavior — THE box authority for a node, in a Layout
container or standing alone.

Inside a container it is the child's sizing input, and edits re-solve the
nearest Layout above (a LayoutItem under a plain grouping node is read at
layout time and now re-solves through that same ancestor walk).

With no Layout anywhere above, a Fixed width still applies: it is fed to
any width-accepting provider on the node, so standalone text wraps to it
(tv#709). \`Hug\`/\`Fill\` give no standalone constraint — there is no solver
to resolve a share against — and a standalone Fixed HEIGHT does nothing to
text, which owns its measured height.

Sizing and placement fields (width/height/depth + modes, flexGrow/flexShrink, positionMode)
are inherited from LayoutItemInput. Sizes are meters. Hug on a leaf only
measures content for behaviors that provide it (e.g. Text), or opted-in
rendered geometry; otherwise it falls back to the explicit size.`,
    fields: [
      {
        key: "measureGeometry",
        type: "boolean",
        label: "Measure Geometry",
        default: !1,
        description: `Measure rendered subtree geometry for Hug sizing on a node without Layout.
Empty geometry keeps the normal sizing fallback; containers and size
receivers retain their authority.`,
        group: "Sizing"
      },
      {
        key: "width",
        type: "number",
        label: "Width",
        default: 1,
        step: 0.01,
        min: 0,
        description: "Explicit width in meters.",
        group: "Sizing"
      },
      {
        key: "height",
        type: "number",
        label: "Height",
        default: 1,
        step: 0.01,
        min: 0,
        description: "Explicit height in meters.",
        group: "Sizing"
      },
      {
        key: "depth",
        type: "number",
        label: "Depth",
        default: 1,
        step: 0.01,
        min: 0,
        description: "Explicit depth in meters.",
        group: "Sizing"
      },
      {
        key: "widthMode",
        type: "enum",
        label: "Width Mode",
        options: [
          "Fixed",
          "Hug",
          "Fill"
        ],
        default: "Fixed",
        description: `How width is determined.
Fixed = use explicit width, Hug = shrink to content, Fill = expand to parent.`,
        group: "Sizing"
      },
      {
        key: "heightMode",
        type: "enum",
        label: "Height Mode",
        options: [
          "Fixed",
          "Hug",
          "Fill"
        ],
        default: "Fixed",
        description: "How height is determined.",
        group: "Sizing"
      },
      {
        key: "depthMode",
        type: "enum",
        label: "Depth Mode",
        options: [
          "Fixed",
          "Hug",
          "Fill"
        ],
        default: "Fixed",
        description: "How depth is determined.",
        group: "Sizing"
      },
      {
        key: "minWidth",
        type: "number",
        label: "Min Width",
        step: 0.01,
        min: 0,
        description: `Minimum width in meters — a floor for Fill/shrink resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "maxWidth",
        type: "number",
        label: "Max Width",
        step: 0.01,
        min: 0,
        description: `Maximum width in meters — a size ceiling, including wrapping for Hug Text.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "minHeight",
        type: "number",
        label: "Min Height",
        step: 0.01,
        min: 0,
        description: `Minimum height in meters — a floor for Fill/shrink resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "maxHeight",
        type: "number",
        label: "Max Height",
        step: 0.01,
        min: 0,
        description: `Maximum height in meters — a ceiling for Fill/grow resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "minDepth",
        type: "number",
        label: "Min Depth",
        step: 0.01,
        min: 0,
        description: `Minimum depth in meters — a floor for Fill/shrink resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "maxDepth",
        type: "number",
        label: "Max Depth",
        step: 0.01,
        min: 0,
        description: `Maximum depth in meters — a ceiling for Fill/grow resolution.
Absent means unconstrained.`,
        group: "Sizing",
        optional: !0
      },
      {
        key: "flexGrow",
        type: "number",
        label: "Flex Grow",
        default: 0,
        step: 0.1,
        min: 0,
        description: `Growth weight along the main axis when the container has free space.
0 = auto: Fill children grow with weight 1, Fixed/Hug children don't.
Set > 0 to weight growth among siblings (like CSS flex-grow).`,
        group: "Flex"
      },
      {
        key: "flexShrink",
        type: "number",
        label: "Flex Shrink",
        default: 1,
        step: 0.1,
        min: 0,
        description: "Flex shrink factor.",
        group: "Flex"
      },
      {
        key: "positionMode",
        type: "enum",
        label: "Position Mode",
        options: ["Auto", "Absolute"],
        default: "Auto",
        description: `Position mode. Auto = arranged by the layout flow.
Absolute = removed from flow: the object keeps its own transform
position, but Fill/percent sizing still resolves against the parent.`,
        group: "Position"
      },
      {
        key: "inset",
        type: "object",
        label: "Inset",
        fields: [{
          key: "left",
          type: "number",
          label: "Left",
          step: 0.01,
          min: 0,
          description: "Distance from the containing box's left edge to the child's left edge.",
          optional: !0
        }, {
          key: "top",
          type: "number",
          label: "Top",
          step: 0.01,
          min: 0,
          description: "Distance from the containing box's top edge to the child's top edge.",
          optional: !0
        }],
        description: `Top-left offset for an Absolute child, in meters, from the containing
box's corner to this child's own corner — CSS \`left\`/\`top\`. Read only
when \`positionMode\` is Absolute; ignored on a flow child, which takes
its position from the flow.

It exists because a corner is the only placement an author can state
ahead of the solve. The transform an Absolute child otherwise keeps is
CENTRE-based, and converting corner to centre needs the containing size
AND the child's own size — neither of which exists until layout runs,
so anything upstream that converts early has to guess both and is wrong
by half the difference whenever either extent is Hug or Fill. The
solver holds both numbers at the moment it places the child.`,
        group: "Position",
        optional: !0
      },
      {
        key: "alignSelfCross",
        type: "enum",
        label: "Align Self Cross",
        options: [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        description: `This item's own alignment on the container's FIRST cross axis,
overriding the container's \`alignCross\` for this child alone — CSS
\`align-self\`. Stretch fills the cross extent.

Unset inherits from the container, which is not the same statement as
setting the container's value explicitly: an inherited value follows the
container when it changes, an authored one does not.`,
        group: "Alignment",
        optional: !0
      },
      {
        key: "alignSelfCrossB",
        type: "enum",
        label: "Align Self Cross B",
        options: [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        description: `This item's own alignment on the container's SECOND cross axis,
overriding \`alignCrossB\` for this child alone. In a vertical container
that is the depth axis, which is how a single card sits proud of the
stack it flows in.

Unset inherits from the container.`,
        group: "Alignment",
        optional: !0
      }
    ]
  },
  {
    type: "MarkerSlot",
    description: "Marks an empty node as a spot where an image marker could sit. Editors use\nit to line a room up with a scene's image marker, or a marker with a room.\nThe node's name is its label.\n\nThe node's local frame is the marker frame `L` of ZIP_FRAME_CONTRACT.md:\n`+X` image-right, `+Y` image-top, `+Z` out of the face. A wall slot has `+Z`\npointing into the room; a table slot has `+Z` up. Lining up is pose\nequality between this node and the marker. The frame convention of the\nreference documents that carry slots is in TraceBackend's\n`EntityType.Reference` doc comment\n(`TraceCms/src/TraceCms.Domain/Enums/EntityType.cs`).\n\nIt has no fields and no runtime effect. Unlike `ContentSlot`, it never fits\nor scales anything. It is not localization data: it names no marker and\nlocalizes nothing (LOCALIZERS.md). The marker's width belongs to the\nscene's marker configuration, not to the slot.",
    fields: []
  },
  {
    type: "MeshBackground",
    description: `MeshBackground — drives the corner-radius morphs of a rounded-background
asset (the design library's \`plane_rounded\` / \`cube_rounded\` rigs), so one
mesh covers sharp rectangle → rounded rectangle → pill/circle.

Geometry only — fill and stroke colours belong to Renderer (the assets
expose them as ordinary material slots). Sizing belongs to MorphStretch:
the stretch morphs translate the corner arcs rigidly, so the radius is
invariant under resize and the two behaviors compose without coordination.

How this differs from Bevel: Bevel regenerates a builtin primitive's
geometry (asset-free, arbitrary radius, baked on export) — prefer it for a
plain rounded slab. MeshBackground exists for the authored library rigs,
whose separate stroke-ring geometry and design-set material slots Bevel
cannot produce.`,
    fields: [{
      key: "cornerRadius",
      type: "number",
      label: "Corner Radius",
      default: 0,
      step: 1e-3,
      min: 0,
      description: `Corner radius in meters, measured on the asset's rest box (CSS-pixel
semantics: an 8 mm radius stays 8 mm at any stretched size). The
authored morphs reach half the rest box's smaller side; a larger
request saturates there. Never larger than half the *current* smaller
side — a shrunken background keeps a valid rounded rect.`
    }, {
      key: "pill",
      type: "boolean",
      label: "Pill",
      default: !1,
      description: "Fully round: radius = half the current smaller side (pill, or circle\nwhen square). Overrides `cornerRadius`."
    }]
  },
  {
    type: "Model",
    description: "Controls 3D model loading and display",
    fields: [{
      key: "fit",
      type: "enum",
      label: "Fit",
      options: [
        "fill",
        "contain",
        "scale-down",
        "cover",
        "none"
      ],
      default: "none",
      description: `How the model meets a layout slot whose proportions differ from its
own — \`object-fit\` for a mesh, in the same vocabulary Image and Video
use for a media quad.

\`none\` (the default) is what every model has always done: the node's
scale is the author's sizing handle, layout measures the geometry
through it and never writes it. A model dropped into a slot keeps its
real-world size, which is the only sane default for a piece of set
dressing placed in metres.

\`contain\` hands the scale to layout: the model is scaled uniformly,
as large as fits inside the slot, never distorted. This is what a
template means when it ships its own geometry for a hole it authored
— a phone body drawn into a card-sized box.

\`scale-down\` is \`contain\` that never enlarges: a model larger than
its slot shrinks to fit, one that already fits keeps its size.

\`fill\` scales per axis to the slot, distorting. A mesh with sculpted
corners or internal parts smears under it; \`MorphStretch\` is the
right tool where the asset authors stretch morphs.

\`cover\` would need to clip against the slot, which the engine cannot
do for a mesh, so it is accepted and clamped to \`contain\` with a
warning rather than silently overflowing.

Only slot-determined axes constrain the fit: an axis the container
Hugs was sized BY this model, and a flat depth axis is the 2D-canvas
convention rather than an instruction to squash the geometry.`
    }, {
      key: "fitAnchor",
      type: "enum",
      label: "Fit Anchor",
      options: ["center", "bottom"],
      default: "center",
      description: "Where a FITTED model sits inside its slot on the vertical axis.\n\n`center` (the default) places the geometry's bounds centre at the\nslot centre — a hero floating in a card. `bottom` seats the bounds\non the slot's floor, which is what a slot standing on a plinth or a\nbench means: a low, wide model (a car) contain-fits by its width and\nwould otherwise hover a hand's width above the surface it was placed\non. Read only under a fitting `fit`; `none` keeps the author's\ntransform whole."
    }]
  },
  {
    type: "MorphStretch",
    description: "Sizes a component mesh to a target box by driving its authored stretch\nmorph targets (`Xp_In`/`Xn_Out`/`Y_Out`… — the design-set convention),\nso borders and corners keep their sculpted proportions where plain node\nscaling would smear them. Axes without morphs fall back to direct mesh\nscaling; axes left undefined keep the authored extent. `fit` chooses how\nthe box is realized: per-axis stretch (default) or an aspect-preserving\nuniform contain fit.",
    fields: [
      {
        key: "width",
        type: "number",
        label: "Width",
        step: 0.01,
        description: "Target width (local X), meters",
        optional: !0
      },
      {
        key: "height",
        type: "number",
        label: "Height",
        step: 0.01,
        description: "Target height (local Y), meters",
        optional: !0
      },
      {
        key: "depth",
        type: "number",
        label: "Depth",
        step: 0.01,
        description: "Target depth (local Z), meters",
        optional: !0
      },
      {
        key: "fit",
        type: "enum",
        label: "Fit",
        options: ["fill", "contain"],
        default: "fill",
        description: `How the target box is realized.

\`fill\` (the default) drives each axis independently — morphs where
the asset authors them, mesh scale where it doesn't — so the geometry
meets the box exactly on every sized axis. \`stretch\` is the pre-#760
spelling of \`fill\`: accepted on the wire and rewritten to \`fill\` on
load and on commit, because TraceFrontend persisted it into scenes.

\`contain\` never distorts: one uniform factor — the minimum of
desired/rest over the sized axes — scales all three axes, and every
stretch morph stays at zero. The geometry keeps its authored
proportions and fits inside the box, meeting it exactly only on the
limiting axis. This is the mode for solid decorative pieces (doodads)
handed a box authored for another component's aspect. Axes without a
size don't constrain the fit.`
      },
      {
        key: "innerWidth",
        type: "number",
        label: "Inner Width",
        step: 0.01,
        description: `Authored inner reference width (local X) at rest, meters — the part of
the asset that should meet the target box. What the measured rest
width has beyond it is decorative overhang (trim, moulding, a lip),
held constant in absolute meters at any size: the realized outer
width becomes \`width + (rest − innerWidth)\`. Kit convention authors
smart types to a 1.0 m inner reference, CENTRED ON THE OBJECT'S PIVOT
— so layout places the pivot at the box centre and the overhang stays
on the side the artist put it (a base's lip rises above its box rather
than being split across both ends). Per-axis: an axis without an inner
value sizes to the box exactly. Ignored by \`fit: 'contain'\`.`,
        optional: !0
      },
      {
        key: "innerHeight",
        type: "number",
        label: "Inner Height",
        step: 0.01,
        description: "Authored inner reference height (local Y) at rest, meters. See\n`innerWidth` — same overhang-preserving rule, on the Y axis.",
        optional: !0
      },
      {
        key: "innerDepth",
        type: "number",
        label: "Inner Depth",
        step: 0.01,
        description: "Authored inner reference depth (local Z) at rest, meters. See\n`innerWidth` — same overhang-preserving rule, on the Z axis.",
        optional: !0
      },
      {
        key: "weight",
        type: "number",
        label: "Weight",
        default: 1,
        step: 0.05,
        description: "The prototype's frame weight (`weightDesignUnits / 24`): a uniform\npre-scale on the meshes. The box is fed to the geometry at `1/weight`\nand the meshes are scaled back by `weight`, so the box is still met\nexactly while the overhang thins with it — the realized outer is\n`box + weight × (rest − inner)`. A kit frame around a template slot\ncarries 0.5 (weight 12); a wrapper's own frame whatever its recipe\nsays. Ignored by `fit: 'contain'`.\n\nA converter-authored kit fact, not an editorial dial — it comes from\nthe frame's own design data, the same way `innerWidth`/etc. do. Hand\nauthoring it on a GLB whose morph targets don't match just thins an\noverhang that isn't there. Slated to move onto the kit GLB as a glTF\n`extras` field, next to the morph targets themselves (#707) — this\nscene-level copy is the interim home."
      },
      {
        key: "range",
        type: "vec2",
        label: "Range",
        description: `The prototype's proxy range, as multiples of the inner reference: the
morphs realize an inner within \`[min, max] × inner\` and the remainder
is plain mesh scale on that axis — an axis without the needed morphs
takes the scale alone. This is how a kit fin asked for 0.36 m renders
at 0.72 m (its 1.0 m rest × 0.36/0.5) and a 0.28 m base at 0.37 m
(0.5 m plus its 0.16 m lip, × 0.56). Kit components carry \`[0.5, 3]\`;
absent, the morph range alone bounds the reach. Needs an inner
reference on the axis; ignored by \`fit: 'contain'\`.

A converter-authored kit fact, same footing as \`weight\` above — it
describes what THIS asset's morph targets can actually reach, not a
stylistic choice. Same interim-home/follow-up as \`weight\` (#707).`,
        optional: !0
      }
    ]
  },
  {
    type: "Moveable",
    description: "Marks an object as moveable by dragging",
    fields: [{
      key: "axes",
      type: "multiSelect",
      label: "Axes",
      options: [
        "x",
        "y",
        "z"
      ],
      description: "Allowed movement axes. When omitted, all axes are allowed.",
      optional: !0
    }, {
      key: "momentumDamping",
      type: "number",
      label: "Momentum Damping",
      default: 0,
      min: 0,
      description: `Release momentum ("flick it and let go"): after a drag ends, the slide
keeps going and eases out with this time constant in seconds — the speed
decays to ~37% per interval, and the total extra travel is release-speed
× this value. 0 or absent = stops dead on release (classic behavior).
Same seconds vocabulary as Billboard/Tether damping. Cross-platform
contract: docs-internal/MANIPULATION_MOMENTUM_SPEC.md.`
    }]
  },
  {
    type: "Pages",
    description: `Pages container — each direct child SceneObject is one page, except the
children listed in \`shared\`. Only the active page is visible; shared
children stay visible on every page.

Hierarchy:
\`\`\`
Presentation (Pages behavior, shared: ["./Model"])
  ├── Model           ← shared child: on every page, posed per page
  │   ├── Step 1         by \`pages[].states\`
  │   └── Step 2
  ├── Page 1          ← page 0 (visible by default)
  │   └── Caption
  └── Page 2          ← page 1 (hidden: authored \`active: false\`)
      └── Caption
\`\`\`

Content of one page lives under that page's child. Content seen on
several pages (a model built up step by step, a nav bar) is a shared
child, and each page sets its look with \`pages[].states\`.

Pages does NOT auto-hide children on load. Non-first pages must
be created with \`active: false\` so they start hidden. Entering play
mode applies the showing page's \`pages[].states\`.

Navigation: use the \`next\` / \`prev\` / \`showPage\` actions, or BehaviorGraph
pagesNext / pagesPrev blocks. Active page index is 0-based.`,
    fields: [
      {
        key: "pages",
        type: "array",
        label: "Pages",
        itemFields: [{
          key: "states",
          type: "string",
          label: "States",
          arrayOf: "{ target: string; state: string }",
          description: "State assignments applied when this page is shown: each target's\nProperties behavior gets `setState(state)`. Objects assigned on any\npage but not on the shown page revert to base (`setState(undefined)`).\nOne assignment per target — later duplicates override earlier ones."
        }],
        itemLabel: "Page Data",
        description: 'Per-page transition configuration, positionally aligned with the page\nchildren (`pages[i]` configures page i). Entries may be empty (`{}`) for\npages with no state assignments; a missing/short array means the remaining\npages have none.\n\nExample — a hero that exits on page 1, and a shared `Model` whose\n`Step 2` group (with a `future` state that sets `active: false`) is\nhidden on page 0 and back at base on page 1:\n```json\n[\n  { "states": [{ "target": "./Page1/Hero", "state": "entered" },\n               { "target": "./Model/Step 2", "state": "future" }] },\n  { "states": [{ "target": "./Page1/Hero", "state": "exitLeft" }] }\n]\n```',
        optional: !0
      },
      {
        key: "transition",
        type: "object",
        label: "Transition",
        fields: [
          {
            key: "duration",
            type: "number",
            label: "Duration",
            min: 0,
            description: "Transition duration in seconds"
          },
          {
            key: "easing",
            type: "enum",
            label: "Easing",
            options: [
              "linear",
              "easeIn",
              "easeOut",
              "easeInOut",
              "snap",
              "back",
              "anticipate"
            ],
            default: "easeInOut",
            description: "Easing function"
          },
          {
            key: "delay",
            type: "number",
            label: "Delay",
            default: 0,
            min: 0,
            description: "Delay before transition starts, in seconds"
          }
        ],
        description: `Default transition for page state changes, applied to any child state
that doesn't define its own transition.
Defaults to 0.5s easeInOut when omitted.`,
        optional: !0
      },
      {
        key: "transitionOrder",
        type: "enum",
        label: "Transition Order",
        options: ["concurrent", "exitFirst"],
        default: "concurrent",
        description: `Ordering of outgoing vs incoming motion on an animated page change —
one axis, two choreographies (room for more, e.g. an enter-first
"cover" mode):

- \`"concurrent"\` (default): today's overlap — the swap is immediate;
  the outgoing page's departure motion runs while the incoming page
  appears (crossfade model).
- \`"exitFirst"\`: the change sequences — every AnimationSequence exit
  clip across the outgoing page's subtree (per-slot \`delay\` honored,
  nested decks excluded — they own their pages) plays to completion
  while the incoming page stays hidden; the swap then runs as if the
  change had begun at that moment, and the autoplay dwell re-anchors
  there. A newer page change cancels a pending swap (last-intent
  wins); re-requesting the SAME target fast-forwards the swap without
  restarting the cascade; returning to the current page repairs the
  in-flight departures. Instant (non-animated) changes bypass
  entirely. With no exit clips on the outgoing page the swap is
  immediate — byte-for-byte the \`"concurrent"\` behavior.`
      },
      {
        key: "advanceOnTap",
        type: "boolean",
        label: "Advance On Tap",
        default: !1,
        description: "Advance to the next page when the user taps this deck's content in\nplay mode — page children and shared children alike. A tap that\nsomething acts on fires that instead and never advances: a behavior\ngraph's onSelect listening on the tapped object or an ancestor,\nruntime selection (Moveable, Rotatable, a `:selected` state), a\nscript, or a tap-to-play video. A collider or `:hover`/`:active`\nstates only make content tappable — such a tap still advances. Taps\non empty space never advance. Wrap follows `loop`\n(off = hold on the last page, on = wrap to the first)."
      },
      {
        key: "autoplay",
        type: "boolean",
        label: "Autoplay",
        default: !1,
        description: "Automatically advance pages in play mode"
      },
      {
        key: "loop",
        type: "boolean",
        label: "Loop",
        default: !1,
        description: "End-of-deck behavior: wrap from the last page back to the first.\nDeck-level, not autoplay-only — it governs autoplay advancement AND\n`advanceOnTap` wrapping alike."
      },
      {
        key: "pageDuration",
        type: "number",
        label: "Page Duration",
        default: 5,
        description: `Duration each page is shown, in seconds. Drives autoplay advancement and
the Playable/Timeline mapping (seek, total duration) — it is the page's
timeline length, not autoplay-only config.`
      },
      {
        key: "pageSource",
        type: "enum",
        label: "Page Source",
        options: ["self", "firstChild"],
        default: "self",
        description: "Which node's children are the pages: `self` — the container's direct\nSceneObject children (default); `firstChild` — children of the\ncontainer's first child TransformNode (e.g. a GLB root)."
      },
      {
        key: "shared",
        type: "string",
        label: "Shared",
        arrayOf: "string",
        description: 'Shared children: paths (relative to the container) of direct children\nthat are NOT pages. A shared child is excluded from the page set — it\npersists across page switches, is never activated/deactivated by page\nnavigation, and is animated per page via ordinary `pages[].states`\nassignments targeting it. An unresolvable path excludes nothing (the\nchild stays a page). Only meaningful for `pageSource: "self"`; ignored\nin `firstChild` mode.',
        optional: !0
      }
    ],
    actions: [
      {
        name: "next",
        label: "Next page"
      },
      {
        name: "prev",
        label: "Previous page"
      },
      {
        name: "showPage",
        label: "Go to a page. Args: (index, animate?) — index is 0-based, animate defaults to false"
      },
      {
        name: "showAllPages",
        label: "Show all pages"
      }
    ]
  },
  {
    type: "ParticleSystem",
    description: `Simplified particle system data.
All particles operate in world space (independent after spawn).`,
    fields: [
      {
        key: "emissionRate",
        type: "number",
        label: "Emission Rate",
        default: 50,
        description: "Particles emitted per second"
      },
      {
        key: "maxParticles",
        type: "number",
        label: "Max Particles",
        default: 1e3,
        description: "Maximum particles alive at once (performance cap)"
      },
      {
        key: "lifetime",
        type: "object",
        label: "Lifetime",
        fields: [{
          key: "min",
          type: "number",
          label: "Min"
        }, {
          key: "max",
          type: "number",
          label: "Max"
        }],
        default: {
          min: 1,
          max: 2
        },
        description: "Particle lifetime range in seconds"
      },
      {
        key: "startColor",
        type: "color",
        label: "Start Color",
        default: "#FFCC00FF",
        description: "Starting color (#RRGGBBAA hex)"
      },
      {
        key: "startColor2",
        type: "color",
        label: "Start Color2",
        description: "Optional second color for random range between startColor and startColor2",
        optional: !0
      },
      {
        key: "endColor",
        type: "color",
        label: "End Color",
        description: `Color particles fade to at end of life (#RRGGBBAA hex).
"#00000000" = fade to fully transparent (alpha 00).
"#000000FF" = fade to opaque black. "#FF0000FF" = fade to red.
With premultiplied blending, RGB channels have no effect when alpha is 0.`,
        optional: !0
      },
      {
        key: "startSpeed",
        type: "object",
        label: "Start Speed",
        fields: [{
          key: "min",
          type: "number",
          label: "Min"
        }, {
          key: "max",
          type: "number",
          label: "Max"
        }],
        default: {
          min: 2,
          max: 4
        },
        description: "Starting speed range (world units/second)"
      },
      {
        key: "gravityModifier",
        type: "number",
        label: "Gravity Modifier",
        default: 0.3,
        description: "Gravity multiplier (-1 = normal gravity down, 0 = no gravity, 1 = reverse)"
      },
      {
        key: "shape",
        type: "object",
        label: "Shape",
        fields: [
          {
            key: "type",
            type: "enum",
            label: "Type",
            options: [
              "Cone",
              "Sphere",
              "Box"
            ]
          },
          {
            key: "radius",
            type: "number",
            label: "Radius",
            description: "Radius for Cone and Sphere shapes (world units)",
            optional: !0
          },
          {
            key: "angle",
            type: "number",
            label: "Angle",
            description: "Angle for Cone shape (degrees, 0-90)",
            optional: !0
          },
          {
            key: "boxSize",
            type: "vec3",
            label: "Box Size",
            description: "Box dimensions [x, y, z] for Box shape (world units)",
            optional: !0
          },
          {
            key: "emitDirection",
            type: "vec3",
            label: "Emit Direction",
            description: `Emission direction for Box shape as a unit vector [x, y, z].
Defaults to [0, 1, 0] (local Y). Unity Rectangle emits along [0, 0, 1] (local Z).`,
            optional: !0
          }
        ],
        default: {
          type: "Cone",
          radius: 0.05,
          angle: 30
        },
        description: "Emission shape configuration"
      },
      {
        key: "texture",
        type: "asset",
        label: "Texture",
        default: "",
        description: `Particle texture asset path (local or URL). ALWAYS premultiplied RGBA — the editor
bakes the source to premultiplied on import (see ParticleTextureMode). Runtimes load
this directly and blend with premultiplied Porter-Duff; they never convert it.`,
        assetType: "image"
      },
      {
        key: "particleScale",
        type: "number",
        label: "Particle Scale",
        description: `Overall particle size multiplier applied on top of sizeOverLifetime keyframes.
Distinct from the object's transform scale which also affects emission shape.`,
        optional: !0
      },
      {
        key: "sizeOverLifetime",
        type: "array",
        label: "Size Over Lifetime",
        itemFields: [{
          key: "time",
          type: "number",
          label: "Time",
          step: 0.01,
          default: 0
        }, {
          key: "value",
          type: "number",
          label: "Value",
          step: 0.01,
          default: 0
        }],
        itemLabel: "Keyframe",
        description: `Size multiplier over lifetime (array of keyframes, time 0-1).
Omit for constant size.`,
        optional: !0
      },
      {
        key: "startRotation",
        type: "object",
        label: "Start Rotation",
        fields: [{
          key: "min",
          type: "number",
          label: "Min"
        }, {
          key: "max",
          type: "number",
          label: "Max"
        }],
        description: "Starting rotation range (degrees)",
        optional: !0
      },
      {
        key: "angularVelocity",
        type: "object",
        label: "Angular Velocity",
        fields: [{
          key: "min",
          type: "number",
          label: "Min"
        }, {
          key: "max",
          type: "number",
          label: "Max"
        }],
        description: "Angular velocity range (degrees/second)",
        optional: !0
      },
      {
        key: "noise",
        type: "object",
        label: "Noise",
        fields: [
          {
            key: "strength",
            type: "vec3",
            label: "Strength",
            description: "Strength of turbulence on each axis (world units). Equal XYZ = uniform."
          },
          {
            key: "frequency",
            type: "number",
            label: "Frequency",
            description: "Noise evolution speed — higher = more chaotic, lower = smoother swirls. Default 0.5",
            optional: !0
          },
          {
            key: "octaves",
            type: "number",
            label: "Octaves",
            description: "Number of noise octaves (1-4). More = finer detail. Default 2",
            optional: !0
          },
          {
            key: "drag",
            type: "number",
            label: "Drag",
            description: `Velocity damping per second (0-1). Controls how quickly noise-induced
velocity decays. 0 = no damping (force accumulates), 1 = full damping
(position-offset behavior, like Unity). Default 0.`,
            optional: !0
          }
        ],
        description: `Noise-based turbulence applied to particle velocity.
Omit or set strength to 0 to disable.`,
        optional: !0
      }
    ]
  },
  {
    type: "Properties",
    description: `Properties — the public interface of a template or scene object.

Declares named, typed properties with initial values, optional external sheets,
and named states for conditional overrides with transitions. A declaration can
also carry \`variants\` (named preset values, shown as a swatch row in editors)
and a default \`transition\` that animates programmatic value changes.

## Binding syntax

Other behaviors reference properties using \`{name}\` in their data fields:
\`\`\`json
{ "@type": "Renderer", "materials": [{ "baseColorFactor": "{color}" }] }
\`\`\`

Expressions are supported inside \`{}\`:
\`\`\`json
{ "@type": "Text", "text": "Distance: {floor(camera.distance)} meters" }
\`\`\`

## Complete example

\`\`\`json
{
  "@type": "Properties",
  "properties": [
    { "name": "color", "type": "color", "value": "#FF0000", "label": "Primary",
      "variants": [ { "name": "Red", "value": "#FF0000" }, { "name": "Teal", "value": "#00AA88" } ],
      "transition": { "duration": 0.3, "easing": "easeOut" } },
    { "name": "fontSize", "type": "number", "value": 16, "min": 8, "max": 48 }
  ],
  "states": {
    ":hover": {
      "values": { "color": "#00FF00" },
      "transition": { "duration": 0.3, "easing": "easeOut" }
    },
    "nearby": {
      "values": { "color": "#0000FF", "fontSize": 24 },
      "transition": { "driver": "camera.distance", "range": [5, 1] }
    }
  },
  "initialState": "nearby"
}
\`\`\``,
    fields: [
      {
        key: "properties",
        type: "array",
        label: "Properties",
        default: [],
        description: "Property declarations — name, type, value, and optional constraints.\n\nEach property is available to descendant behaviors via `{name}` bindings.\nThe `value` is the default when no state is active and no ancestor\noverrides the property."
      },
      {
        key: "transform",
        type: "object",
        label: "Transform",
        fields: [
          {
            key: "position",
            type: "vec3",
            label: "Position",
            description: "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
            optional: !0
          },
          {
            key: "rotation",
            type: "vec4",
            label: "Rotation",
            description: "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
            optional: !0
          },
          {
            key: "scale",
            type: "vec3",
            label: "Scale",
            description: "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
            optional: !0
          }
        ],
        description: `The object's own pose at the **base** level — no state involved.

Same absolute-per-component semantics as a state's
TransformOverride: an omitted field keeps the authored value.
The difference is when it applies — a state's transform applies while
that state is active, this one applies whenever no state overrides it,
and it is the baseline a state reverts to.

Its reason to exist is bound components: \`[1, "{stageHeight}", 1]\` makes
the pose a function of a declared property, re-applied whenever that
value changes. Without it a property can only drive fields on behaviors,
never the transform of the object carrying them.

\`\`\`json
{ "@type": "Properties", "properties": [], "transform": { "scale": [1, "{stageHeight}", 1] } }
\`\`\``,
        optional: !0
      },
      {
        key: "sheets",
        type: "string",
        label: "Sheets",
        arrayOf: "string",
        description: `External property sheet URLs. Each URL points to a JSON file — either a
bare \`PropertyDeclaration[]\` (v0) or a PropertySheet envelope.
Declarations from sheets are merged with inline \`properties\` — inline
declarations override sheet declarations at the same name.

Order is meaningful: among sheets, the **first** to declare a name supplies
it.

**This is also how a style is applied.** A style asset *is* a sheet, so
applying one is storing its URL here and swapping styles is replacing that
entry — the applied style is the stored reference, with nothing inferred
from values. By editor convention the entry at index 0 is the style slot
(highest sheet precedence); further entries are ordinary declaration
sheets or layered partial styles. See \`docs/STYLES.md\`.`,
        optional: !0
      },
      {
        key: "states",
        type: "object",
        label: "States",
        fields: [
          {
            key: "values",
            type: "object",
            label: "Values",
            fields: [],
            isMap: !0,
            description: `Property value overrides. Keys are property names from declarations.
Values must match the property's declared type.
Properties not listed keep their value (or ancestor override).`
          },
          {
            key: "transform",
            type: "object",
            label: "Transform",
            fields: [
              {
                key: "position",
                type: "vec3",
                label: "Position",
                description: "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
                optional: !0
              },
              {
                key: "rotation",
                type: "vec4",
                label: "Rotation",
                description: "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
                optional: !0
              },
              {
                key: "scale",
                type: "vec3",
                label: "Scale",
                description: "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
                optional: !0
              }
            ],
            description: `Transform overrides applied to the owning SceneObject when the state is active.
Interpolated alongside property values during transitions.`,
            optional: !0
          },
          {
            key: "active",
            type: "boolean",
            label: "Active",
            description: "Active (enabled) override. When the top eligible state declares\n`active: false`, the owning object is hidden after the state's transition\ncompletes. `active: true` shows it immediately so the object is visible\nduring entry animation. Runtime only: the object's authored `active` is\nunchanged. Omitted means no change.",
            optional: !0
          },
          {
            key: "enterFrom",
            type: "object",
            label: "Enter From",
            fields: [
              {
                key: "position",
                type: "vec3",
                label: "Position",
                description: "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
                optional: !0
              },
              {
                key: "rotation",
                type: "vec4",
                label: "Rotation",
                description: "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
                optional: !0
              },
              {
                key: "scale",
                type: "vec3",
                label: "Scale",
                description: "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
                optional: !0
              }
            ],
            description: 'Entry pose for objects becoming active (inactive → active). When the runtime\ntransitions an object from `active:false` to `active:true` with `enterFrom`\nset, the "from" pose for transform interpolation is this **absolute local\npose** instead of the live pose (omitted fields fall back to the target pose).\nSame absolute semantics as `transform`.',
            optional: !0
          },
          {
            key: "transition",
            type: "string",
            label: "Transition",
            description: `Transition config for entering this state.

- **Time-driven** (\`{ duration, easing?, delay? }\`): animates over a fixed duration
- **Property-driven** (\`{ driver, range?, easing? }\`): progress tracks a live value

Without a transition, values snap immediately.`,
            optional: !0
          }
        ],
        isMap: !0,
        description: "Named states — conditional property value overrides with optional\ntransform overrides and transitions.\n\n**Pseudo-states** (names starting with `:`) auto-trigger from events:\n- `:hover` — pointer enters/exits the object\n- `:active` — pointer is pressed on the object\n- `:selected` — object is selected via click-to-select\n\n**Custom states** are activated programmatically via `setState()` or `initialState`.\n\nStates stack by priority: `:active` (40) > `:selected` (30) > `:hover` (20) > custom (10).\nPer-property, the highest-priority state providing a value wins.",
        optional: !0
      },
      {
        key: "initialState",
        type: "string",
        label: "Initial State",
        description: "State name to activate when the scene enters play mode.\nMust reference a key in `states`. Useful for property-driven transitions\nthat should be active from the start (e.g. camera-distance effects).",
        optional: !0
      },
      {
        key: "stateGroup",
        type: "boolean",
        label: "State Group",
        description: `When \`true\`, this object OWNS its state group and is a *group boundary*. Its
state list is independent of any group above it, so an outer group's state
coordination (add / rename / delete / switch fan-out) stops at this object and
does not reach into its subtree. This is what lets, e.g., a model keep its own
"separated" states while sitting inside an ancestor group, the two combining
independently.

**Runtime-load-bearing.** \`trace/setState(target, s)\` is a SCOPED runtime op:
it walks the target's subtree and sets every participating descendant's slot,
pruning at \`stateGroup\` boundaries (see docs/canopy/STATE_SCOPE_SPEC.md §3 and
core/canopy/stateScope.ts). Runtimes MUST honor this marker (a boundary and
its subtree are excluded from an ancestor's scoped set); exporters MUST
preserve it. A plain boolean marker — the group is identified by the object,
not a separate axis name. See docs-internal/STATE_GROUP_BOUNDARIES.md.`,
        optional: !0
      }
    ],
    docs: "### Properties (discriminator: `type`)\n\nBase interface for all property declarations.\n\n**Common fields** (shared by all variants):\n- `name`: string — Property identifier — used in `{name}` bindings and state value overrides\n- `label`: string (optional) — Display label for editor UI. Makes the property discoverable by AutoUI.\n- `hidden`: boolean (optional) — Keep the property out of generated controls (AutoUI). It stays declared,\n  bindable and editable in an inspector — this is for values that are\n  *driven* rather than adjusted: a page's deck height set by page\n  selection, a compiled offset. Runtimes ignore it.\n- `inherits`: boolean (optional) — Whether this property inherits its value from an ancestor.\n  - `true` (default): \"I inherit from my parent\" — ancestor value wins.\n  - `false`: \"I don't inherit\" — local value wins, ancestor walk skipped.\n  Like CSS `@property { inherits }`, but per-declaration rather than global.\n- `transition`: TimeTransition (optional) — Default transition for programmatic value changes (CSS: `transition: color .3s`).\n  Precedence: an initiator's explicit transition (a state's `transition`, a\n  graph edge's config, a `setValue` argument) wins; this is the fallback; no\n  transition anywhere = snap. Never consulted for instant (snap) recomputes.\n  Time-driven only by type.\n\n| `type` | Description | Extra fields | Requirements |\n|---|---|---|---|\n| `string` | String property declaration | `value`: string, `kind?`: StringPropertyKind | — |\n| `number` | Numeric property declaration with optional constraints for editor UI. | `value`: number, `units?`: Units, `min?`: number, `max?`: number, `step?`: number, `uiHint?`: 'slider' | 'input' | — |\n| `boolean` | Boolean property declaration | `value`: boolean | — |\n| `vec3` | 3D vector property declaration | `value`: [number, number, number], `units?`: Units | — |\n| `vec4` | 4D vector property declaration for generic 4-component data (RGBA, weights, etc.) | `value`: [number, number, number, number] | — |\n| `color` | Color property declaration (hex string) | `value`: string, `variants?`: { name: string; value: string }[] | — |"
  },
  {
    type: "Provenance",
    description: `Provenance behavior data.

Inert: nothing in the runtime reads this, and nothing renders from it. It
exists so a finished scene can answer "what made you" — for remixing, for
attribution, and so the artifacts of a generation run stay attached to the
scene instead of to a sidecar file that gets separated from it.`,
    fields: [
      {
        key: "source",
        type: "enum",
        label: "Source",
        options: [
          "trace-ai",
          "remix",
          "import"
        ],
        description: "What produced the scene.",
        optional: !0
      },
      {
        key: "prompt",
        type: "string",
        label: "Prompt",
        description: "The creator's own words. Verbatim — never normalized or truncated.",
        optional: !0
      },
      {
        key: "mode",
        type: "string",
        label: "Mode",
        description: "Generation mode, e.g. `auto` / `template` / `scratch`.",
        optional: !0
      },
      {
        key: "template",
        type: "string",
        label: "Template",
        description: "Template slug that answered, e.g. `card-feature`. Never a model id.",
        optional: !0
      },
      {
        key: "style",
        type: "string",
        label: "Style",
        description: "Style slug applied to the root, e.g. `aurora`.",
        optional: !0
      },
      {
        key: "label",
        type: "string",
        label: "Label",
        description: `Role label for display, e.g. "Trace AI · layout".

Deliberately the same label the generator already shows a creator, and
deliberately not a model name: which model answered is a routing detail
that changes under us, and baking it into published scenes would turn
every routing change into a fleet of stale claims.`,
        optional: !0
      },
      {
        key: "generatedAt",
        type: "string",
        label: "Generated At",
        description: "ISO-8601 timestamp of the run.",
        optional: !0
      },
      {
        key: "remixOf",
        type: "string",
        label: "Remix Of",
        description: "The scene this one was derived from, when it was derived from one.",
        optional: !0
      },
      {
        key: "assets",
        type: "array",
        label: "Assets",
        itemFields: [
          {
            key: "ref",
            type: "string",
            label: "Ref",
            description: `The reference recorded when this asset was generated.

This is inert generation history, not a file dependency. Export carries
the assets record without fetching or rewriting its values; the scene
node that actually uses an asset owns validation and bundling. Legacy
records named this field \`src\`; their metadata is carried the same way.`
          },
          {
            key: "via",
            type: "string",
            label: "Via",
            description: "How it was made: a generator slug (`imagegen`, `trellis2`), or `catalog` when it was found rather than made."
          },
          {
            key: "prompt",
            type: "string",
            label: "Prompt",
            description: "The instruction behind it, when it had one of its own."
          }
        ],
        itemLabel: "Provenance Asset",
        description: "Generated art and models with their recorded references (see `ProvenanceAsset.ref`).",
        optional: !0
      },
      {
        key: "bakedFrom",
        type: "string",
        label: "Baked From",
        description: `The asset this object's \`src\` was baked FROM — its authored, still-rigged
original.

Export bakes live deformation into geometry and points \`src\` at a
generated \`morphbake_<hash>.glb\`, which renders correctly everywhere and
re-edits nowhere: the morph targets are gone, so a re-imported component
can never be re-stretched. This records the way back. A Bevel'd
primitive bakes the same way, to \`bevel_<host>_<hash>.glb\`, and records
the primitive under the modifier (\`builtin:primitive_cube.glb\`), so an
authoring load reopens that primitive with its Bevel instead of a Model
on the bake. An extruded Text's body bakes to \`text3d_<hash>.glb\` and
records \`builtin:none\`: there was no \`src\`, and an authoring load opens
none, so the Text builds its body again.

True only beside the bake it was written with. Every bake writes it from
the src it replaces, so a form swapped in since the last save is what the
next re-open gets. A src that is itself a bake keeps the note it came
with — the rig, not the previous bake; with none, a Bevel bake (a rounded
primitive, still stretchable) is recorded and a deformation bake is not.
Beside any other src the note is
dropped on export and ignored on load: it names a form the object no
longer has.

Unlike ProvenanceAsset.ref — inert generation history — this
names an asset that may exist ONLY here, so the
export bundles it like any other reference. That is the cost of
re-editability: the archive carries the baked geometry and the rig it
was baked from.

Read only when a load declares itself an authoring session
(\`ConfigData.playMode === false\`); a runtime carries it untouched and
renders the baked \`src\`, which is the published contract.`,
        optional: !0
      },
      {
        key: "placedFrom",
        type: "string",
        label: "Placed From",
        description: `The reference this content was placed from, before unpack dissolved it.

Placing a library asset or a \`.trace\` leaves a reference: one wrapper
node whose \`src\` is the URL, with the file's content underneath as
derived material. \`unpack\` (#730) is the inverse — the content becomes
the scene's own and the wrapper goes away, and with it the only record
that any of this came from somewhere. This is that record.

Stamped **only on unpack** (spec §3.4). A plain import does not need it:
the reference node is still standing and still carries the URL, so a
second copy could only rot out of step with the first. Editors read it
for "placed from <asset>" provenance and to offer a re-link; nothing
fetches it and nothing renders from it.

Always an absolute http(s) URL, so for a library reference it is an
asset file URL and \`parseAssetFileUrl\` recovers the id. Deliberately not
a local \`assets/…\` path: an unpack with no URL behind it has no
provenance to record, and a local path here would be a second, weaker
name for bytes the archive already carries.`,
        optional: !0
      }
    ]
  },
  {
    type: "RecordingInfo",
    fields: [
      {
        key: "formatVersion",
        type: "number",
        label: "Format Version",
        default: 2,
        step: 1,
        min: 1,
        description: "Recording format version. `2` for recordings that live inside a scene\ndocument (this format)."
      },
      {
        key: "capturedAt",
        type: "string",
        label: "Captured At",
        description: "When capture started, as an ISO-8601 timestamp (e.g. `2026-09-26T14:03:11Z`).",
        optional: !0
      },
      {
        key: "author",
        type: "object",
        label: "Author",
        fields: [{
          key: "id",
          type: "string",
          label: "Id",
          description: "The author's user id.",
          optional: !0
        }, {
          key: "name",
          type: "string",
          label: "Name",
          description: "The author's display name at capture time.",
          optional: !0
        }],
        description: "Who made the recording.",
        optional: !0
      },
      {
        key: "device",
        type: "string",
        label: "Device",
        description: "The capturing device, informational (e.g. `iPhone15,2`).",
        optional: !0
      },
      {
        key: "app",
        type: "string",
        label: "App",
        description: "The capturing app and version, informational.",
        optional: !0
      },
      {
        key: "capture",
        type: "object",
        label: "Capture",
        fields: [{
          key: "face",
          type: "enum",
          label: "Face",
          options: ["arkit", "none"],
          description: "Face source: `arkit` for ARKit blendshapes, `none` for a recording with\nno face (Android, a sequence-only recording).",
          optional: !0
        }, {
          key: "clock",
          type: "enum",
          label: "Clock",
          options: ["arframe", "frame"],
          description: "Key timestamps: `arframe` when keys carry the ARKit frame timestamp\n(§3.1), `frame` when they carry a render-frame clock (v1 conversions).",
          optional: !0
        }],
        description: "How the data was captured and stamped.",
        optional: !0
      },
      {
        key: "frame",
        type: "object",
        label: "Frame",
        fields: [
          {
            key: "origin",
            type: "enum",
            label: "Origin",
            options: ["head", "scene"],
            description: "`head`: origin at the first performer's first head position, +Y up, and\n+Z the horizontal facing of that head. `scene`: no head pose to anchor\nto (voice- or tracks-only); the frame is the capture scene's canonical\nanchor frame.",
            optional: !0
          },
          {
            key: "up",
            type: "enum",
            label: "Up",
            options: ["gravity", "scene"],
            description: "Where +Y came from: `gravity` (a native recorder: ARKit's\ngravity-aligned world) or `scene` (a v1 conversion: the canonical anchor\nframe's +Y, assumed level).",
            optional: !0
          },
          {
            key: "startHeight",
            type: "number",
            label: "Start Height",
            description: `The first head position's height above the capture scene's origin, in
metres. A placement hint: the \`Recording\` node marks where the head
starts, so an editor dropping the recording on a floor can raise it by
this much.`,
            optional: !0
          }
        ],
        description: "How the recording frame was chosen (§3.2).",
        optional: !0
      },
      {
        key: "migratedFrom",
        type: "string",
        label: "Migrated From",
        description: "The v1 scene-content id this recording was converted from (§9). Absent\n— or `null`, which a scene save drops — for a native recording.",
        optional: !0
      }
    ]
  },
  {
    type: "Renderer",
    description: "Controls shadow casting and materials for renderers",
    fields: [
      {
        key: "castShadows",
        type: "boolean",
        label: "Cast Shadows",
        default: !0,
        description: "Whether renderer casts shadows"
      },
      {
        key: "materials",
        type: "array",
        label: "Materials",
        itemFields: [
          {
            key: "src",
            type: "string",
            label: "Src",
            description: `Source URL or path to the material GLB file
Optional - only included when material replacement is applied
Excluded when only property changes (color/UV) are made`
          },
          {
            key: "targetMaterialIndex",
            type: "number",
            label: "Target Material Index",
            step: 0.01,
            default: 0,
            description: `Target material slot index (0-based).

This is a MESH slot index, not a glTF material index: slots are enumerated
per mesh, so meshes that shared one authored glTF material appear as
several slots. Editors must therefore fan a single material choice out
across every slot carrying that original material.`
          },
          {
            key: "baseColorFactor",
            type: "color",
            label: "Base Color Factor",
            description: "Base color, #RRGGBB or #RRGGBBAA. An alpha byte below FF alpha-blends this slot on its own; 00 hides it without writing depth."
          },
          {
            key: "opacity",
            type: "number",
            label: "Opacity",
            step: 0.01,
            default: 1,
            description: `Opacity of this slot alone (0 = fully transparent, 1 = fully opaque).
Absent, or 1, leaves the slot's material as the model authored it; \`0\` is
a real value and hides the slot without writing depth.

Below 1 the slot alpha-blends on its own copy of the material, so the
object's other slots and other placements of the same model are
untouched. It multiplies with the whole-object \`opacity\` and with the alpha
byte of a \`#RRGGBBAA\` \`baseColorFactor\` on the same slot: the slot's alpha
is slot opacity × object opacity × colour alpha. Withdrawing it, or setting
1, hands the material's authored transparency back. An occluder material
ignores it.

Published files carry it in \`Renderer.materials[]\` like any other slot
override, and a baked GLB also carries the resulting alpha on the slot's
material (\`baseColorFactor[3]\` with \`alphaMode: BLEND\`). A player that
does not read this field shows the slot at its authored alpha.`
          },
          {
            key: "roughnessFactor",
            type: "number",
            label: "Roughness Factor",
            step: 0.01,
            default: 0,
            description: "PBR roughness factor (0 = mirror-smooth, 1 = fully diffuse).\nReplaces the material's authored roughness for this slot.\nAbsent = keep whatever the material authored; `0` is a valid override."
          },
          {
            key: "metallicFactor",
            type: "number",
            label: "Metallic Factor",
            step: 0.01,
            default: 0,
            description: "PBR metallic factor (0 = dielectric, 1 = metal).\nReplaces the material's authored metallic for this slot.\nAbsent = keep whatever the material authored; `0` is a valid override."
          },
          {
            key: "emissiveFactor",
            type: "string",
            label: "Emissive Factor",
            description: `Emissive color, #RRGGBB (a trailing alpha byte is accepted and ignored).
Replaces the material's authored emissive for this slot; \`#000000\` is a
valid override meaning "not emissive".

The glow a screen, a sign or a filament has on its own, independent of
scene lighting — the same quantity glTF core calls \`emissiveFactor\`, so
an exported scene carries it in vanilla glTF with no extension.
Absent = keep whatever the material authored.`
          },
          {
            key: "texture_transform",
            type: "string",
            label: "Texture_transform",
            description: "Texture transform settings for UV scaling"
          }
        ],
        itemLabel: "Material Data",
        description: `Array of materials applied to this renderer
Each material corresponds to a material slot on the 3D object`,
        optional: !0
      },
      {
        key: "pickThrough",
        type: "boolean",
        label: "Pick Through",
        default: !1,
        description: `Let pointer picks pass through this object's own meshes in play mode,
including its colliders and embedded controls. Child SceneObjects retain
their own policy. Edit-mode selection is unchanged. Independent of opacity.`
      },
      {
        key: "opacity",
        type: "number",
        label: "Opacity",
        default: 1,
        description: "Whole-object opacity (0 = fully transparent, 1 = fully opaque).\nAutomatically manages transparency mode on all meshes; multiplies into a slot's own `opacity`\nand into a slot whose baseColorFactor carries its own alpha."
      },
      {
        key: "tint",
        type: "string",
        label: "Tint",
        description: `Whole-model tint (#RRGGBB or #RRGGBBAA hex; a trailing alpha byte is
accepted but ignored — use \`opacity\` for transparency). Multiplies into
every material's authored base color across ALL slots — GLB-authored
textured materials included — unlike the per-slot material color, which
replaces one slot's color. Empty or absent = no tint.`,
        optional: !0
      }
    ]
  },
  {
    type: "RestRelativeBinding",
    fields: [{
      key: "nodes",
      type: "string",
      label: "Nodes",
      arrayOf: "string",
      default: [],
      description: "Node names in the bound instance whose bound rotations are rest-relative."
    }]
  },
  {
    type: "Rotatable",
    description: "Marks an object as rotatable by the user",
    fields: [{
      key: "axes",
      type: "multiSelect",
      label: "Axes",
      options: [
        "x",
        "y",
        "z"
      ],
      description: "Allowed rotation axes. When omitted, all axes are allowed.",
      optional: !0
    }, {
      key: "momentumDamping",
      type: "number",
      label: "Momentum Damping",
      default: 0,
      min: 0,
      description: `Release momentum ("spin it and let go"): after a drag ends, the spin
keeps going and eases out with this time constant in seconds — the rate
decays to ~37% per interval, and the total extra sweep is release-rate ×
this value. 0 or absent = stops dead on release (classic behavior).
Same seconds vocabulary as Billboard/Tether damping. Cross-platform
contract: docs-internal/MANIPULATION_MOMENTUM_SPEC.md.`
    }]
  },
  {
    type: "Rotate",
    description: "Continuous rotation animation applied to the animation root",
    fields: [
      {
        key: "axis",
        type: "enum",
        label: "Axis",
        options: [
          "x",
          "y",
          "z",
          "Random"
        ],
        default: "y",
        description: 'Rotation axis. "Random" picks a random normalized axis on attach.'
      },
      {
        key: "speed",
        type: "number",
        label: "Speed",
        default: 45,
        step: 5,
        description: "Base rotation speed in degrees per second"
      },
      {
        key: "speedRange",
        type: "number",
        label: "Speed Range",
        default: 0,
        step: 10,
        description: `Speed randomization range (+/-). Runtime speed = speed ± random(speedRange).
For example, speed=180 and speedRange=60 gives a runtime speed in [120, 240].`
      }
    ]
  },
  {
    type: "SphereCollider",
    description: "Sphere-shaped collider for physics and interaction detection",
    fields: [{
      key: "radius",
      type: "number",
      label: "Radius",
      default: 0.5,
      step: 0.1,
      description: "Radius of the sphere collider"
    }, {
      key: "center",
      type: "vec3",
      label: "Center",
      default: [
        0,
        0,
        0
      ],
      description: "Center offset of the collider relative to the transform"
    }]
  },
  {
    type: "Synth",
    description: "Oscillator-based synthesizer with ADSR envelope and spatial audio",
    fields: [
      {
        key: "waveform",
        type: "enum",
        label: "Waveform",
        options: [
          "sine",
          "square",
          "sawtooth",
          "triangle"
        ],
        default: "sine",
        description: "Oscillator waveform shape"
      },
      {
        key: "note",
        type: "number",
        label: "Note",
        default: 60,
        step: 1,
        min: 0,
        max: 127,
        description: `Default MIDI note number (0–127). Middle C = 60.
Ignored when frequency is set.`
      },
      {
        key: "frequency",
        type: "number",
        label: "Frequency",
        step: 1,
        min: 20,
        max: 2e4,
        description: "Frequency in Hz. When set, overrides the MIDI note value.",
        optional: !0
      },
      {
        key: "volume",
        type: "number",
        label: "Volume",
        default: 0.5,
        step: 0.05,
        min: 0,
        max: 1,
        description: "Master volume (0–1)"
      },
      {
        key: "attack",
        type: "number",
        label: "Attack",
        default: 0.01,
        step: 0.01,
        min: 0,
        max: 5,
        description: "Envelope attack time in seconds (ramp from 0 to peak)"
      },
      {
        key: "decay",
        type: "number",
        label: "Decay",
        default: 0.1,
        step: 0.01,
        min: 0,
        max: 5,
        description: "Envelope decay time in seconds (ramp from peak to sustain level)"
      },
      {
        key: "sustain",
        type: "number",
        label: "Sustain",
        default: 0.7,
        step: 0.05,
        min: 0,
        max: 1,
        description: "Envelope sustain level (0–1). Held after decay until release."
      },
      {
        key: "release",
        type: "number",
        label: "Release",
        default: 0.3,
        step: 0.01,
        min: 0,
        max: 10,
        description: "Envelope release time in seconds (ramp from sustain to 0)"
      },
      {
        key: "duration",
        type: "number",
        label: "Duration",
        default: 0.5,
        step: 0.1,
        min: 0,
        max: 30,
        description: "Auto-release after this many seconds. 0 = sustain indefinitely until stop()."
      },
      {
        key: "spatial",
        type: "boolean",
        label: "Spatial",
        default: !0,
        description: "Enable 3D spatial audio (PannerNode positioned at object transform)"
      },
      {
        key: "minDistance",
        type: "number",
        label: "Min Distance",
        default: 1,
        step: 0.5,
        min: 0,
        description: "Spatial: distance at which volume is at maximum"
      },
      {
        key: "maxDistance",
        type: "number",
        label: "Max Distance",
        default: 50,
        step: 1,
        min: 0,
        description: "Spatial: distance at which volume reaches zero"
      },
      {
        key: "rolloff",
        type: "number",
        label: "Rolloff",
        default: 1,
        step: 0.1,
        min: 0,
        max: 10,
        description: "Spatial: how quickly volume attenuates with distance"
      },
      {
        key: "playOnStart",
        type: "boolean",
        label: "Play On Start",
        default: !1,
        description: "Automatically play the default note when play mode starts"
      }
    ]
  },
  {
    type: "Tether",
    description: "Makes an object continuously follow the user or another object",
    fields: [
      {
        key: "enabled",
        type: "boolean",
        label: "Enabled",
        default: !0,
        description: `Whether following is active when play mode starts. When false the object
stays put until the behavior graph enables it (trace/setBehaviorEnabled).
Disabling at runtime stops it where it is; re-enabling re-runs \`delay\`.
Every play-mode start resets to this value.`
      },
      {
        key: "target",
        type: "string",
        label: "Target",
        default: "",
        description: `What to follow: a TransformPath to another scene object, or empty to
follow the user (the active camera).`
      },
      {
        key: "keepDistance",
        type: "number",
        label: "Keep Distance",
        default: 1,
        description: `Comfort buffer in meters — the object stops approaching once within
this distance, and backs away when the target comes closer than
75% of it.`
      },
      {
        key: "axes",
        type: "multiSelect",
        label: "Axes",
        options: [
          "x",
          "y",
          "z"
        ],
        description: `World axes the object may move along. Omit for all three. The classic
AR panel follows on ["x","z"] — trailing left/right and near/far while
keeping its authored height as the user squats or stands.`,
        optional: !0
      },
      {
        key: "speed",
        type: "number",
        label: "Speed",
        default: 1.5,
        description: "Maximum movement speed in meters per second."
      },
      {
        key: "damping",
        type: "number",
        label: "Damping",
        default: 0.25,
        description: `Movement smoothing as a time constant in seconds — larger trails more
softly (arrival eases in). 0 moves linearly at full speed.`
      },
      {
        key: "delay",
        type: "number",
        label: "Delay",
        default: 0,
        description: `Seconds the target must stay out of range before the object starts
moving — the natural "notice, then catch up" trail.`
      }
    ]
  },
  {
    type: "Text",
    description: `Renders a string of text in 3D space.

Text is the canonical authoring primitive for labels, signage, captions, and
any flat typographic content in a scene. The spec is engine-agnostic: every
implementation (Babylon, Unity, native) renders the same \`TextData\` to a
visually equivalent result, within font-availability constraints.

## Units at a glance

| Concept           | Unit                                                |
|-------------------|-----------------------------------------------------|
| \`fontSize\`        | Em-relative; \`100\` = 1 world-unit em-square         |
| \`strokeWidth\`     | Em fraction (\`0\` – \`0.05\`)                          |
| \`letterSpacing\`   | Em units (fraction of \`fontSize\` em-square)         |
| \`lineHeight\`      | Multiplier of em-square (CSS-style)                 |
| \`color\`           | Hex \`#RRGGBB\` or \`#RRGGBBAA\`                        |
| \`opacity\`         | Alpha multiplier (\`0\` – \`1\`) on fill and stroke     |
| \`depth\`           | Em units (extrusion behind the glyphs)              |

Everything sized "relative to text" is expressed in **em units** — fractions
of the \`fontSize\` em-square. This is the same convention used by CSS, web
typography, and the major 3D text libraries (troika-three-text, Unity TMP
rich text, RealityKit). One ruler for size, stroke, and tracking.

## Font Size — em-square model

\`fontSize\` measures the **em-square** in centi-world-units. \`fontSize: 100\`
is a 1 world-unit (1 metre) em-square. Visible cap-height (the height of
\`H\`, \`E\`) depends on the typeface — typical sans-serifs render \`H\` at
roughly 70% of em, so \`fontSize: 100\` produces a visible cap of ~70 cm in
Roboto, ~75 cm in a display face like Anton, ~66 cm in a slim serif.

This is the same model as CSS \`font-size: 16px\`: setting a single fontSize
across multiple typefaces produces visibly different letter heights, and
that variance is part of what makes typefaces distinctive. Authors who
want consistent visible letter heights across families pick faces with
similar cap-height ratios (Roboto and Inter, both ≈0.71, are close enough
to be interchangeable at the same \`fontSize\`).

### Sizing reference for typical sans-serifs (1 world-unit = 1 metre)

| \`fontSize\` | Em-square | Visible cap (\`H\`) | Use case                             |
|-----------:|----------:|------------------:|--------------------------------------|
| \`0.9\`      | 9 mm      | 6 mm              | Comfortable reading at 45 cm (palm)  |
| \`3.5\`      | 35 mm     | 25 mm             | Comfortable reading at 2 m           |
| \`7\`        | 7 cm      | 5 cm              | Small labels                         |
| \`14\`       | 14 cm     | 10 cm             | Arm's-length signage (default)       |
| \`28\`       | 28 cm     | 20 cm             | Large signage                        |
| \`100\`      | 1 m       | ~70 cm            | Architectural scale                  |

The cap-height column reflects Microsoft's MR legibility recommendations:
\`fontSize: 14\` produces ~10 cm visible H, comfortable at arm's-length;
\`fontSize: 3.5\` ≈ 25 mm visible H, comfortable at 2 m.

## Anchoring

\`anchorX\` and \`anchorY\` together specify where the SceneObject origin sits
within the rendered text box, *and* — for multi-line text — how lines are
aligned with respect to one another.

- \`anchorX: "left"\` — origin at the left edge; lines left-aligned.
- \`anchorX: "center"\` — origin at the horizontal centre; lines centred.
- \`anchorX: "right"\` — origin at the right edge; lines right-aligned.
- \`anchorY: "top"\` — origin at the top of the first line: the face's cap line (see "The text box").
- \`anchorY: "middle"\` — origin at the vertical centre of the box.
- \`anchorY: "bottom"\` — origin at the bottom of the last line.

Default \`("center", "middle")\` matches a freestanding 3D label. For a label
pinned to a marker, set \`anchorY: "bottom"\` so the text floats above the
pinned point.

The conflation of "horizontal anchor" and "line alignment" into one
\`anchorX\` field is deliberate: in 3D space the two are almost always
desired together. Authors needing them split (e.g. left-aligned lines
inside a centred box) compose with a parent transform offset.

## The text box — line boxes, not ink

The rendered text box (what \`anchorX\`/\`anchorY\` anchor, what the Layout
system measures, what editors show) is the CSS-style **line-box** rect:
every line contributes exactly \`lineHeight × fontSize\` of height, so a
paragraph's box is \`lineCount × lineHeight × fontSize\` tall regardless of
which glyphs it contains — two same-fontSize labels get the same height
whether or not one has a descender, and leading is part of the box. Width
is the widest line's advance width. (The tight ink bounds of the actual
glyph quads are an implementation detail, not the box.)

A top-anchored box starts at the face's cap line. A face keeps empty space
between its line top and its capitals (a quarter to a third of an em in the
bundled faces), and with \`anchorY: "top"\` the box does not begin there: it
begins at the top of the face's capital H, so a capital's ink, not the
face's spare ascent, sits on the anchor. That depth is one number per face,
read from the font and never from the text: editing "Once" to "once", or
emptying the first line, does not move the paragraph, and ink taller than a
capital (ascenders, accents, brackets) rises above the box as a descender
falls below it. A face with no H uses 0.3 of its ascent, and one with no
baseline either starts at the line top. The other anchors
are unchanged, and the box's height and centre are the same for every
anchor, measured with or without a font atlas.

## Wrapping & sizing

Standalone text is intrinsic-size: explicit \`\\n\` breaks only, box as
above. **\`TextData\` has no \`maxWidth\` of its own.** Wrapping is
delegated to the Layout system: place a Text behavior on a SceneObject
that also has a \`LayoutItem\`, and the layout-resolved width — a Fixed
width, a Fill share, or a Stretch cross-axis slot — is the wrap width.
This separation mirrors CSS (a \`<span>\` is intrinsic; a sized container
wraps its inline content) and avoids duplicating sizing semantics. Text
whose width is Hug has nothing to wrap against and stays on one line per
explicit break, unless its \`LayoutItem\` authors a \`maxWidth\`: a Hug
\`maxWidth\` is a wrap ceiling, inside a Layout or standalone, and a
narrower ancestor width still wins. A ceiling only limits wrapping. It is
not a slot, so short \`anchorX: "left"\` / \`"right"\` text keeps its own box
and does not move.

Wrapping is greedy and space-delimited: an explicit line that fits its
constraint stays verbatim; one that doesn't is re-broken at spaces, and a
single word wider than the constraint overflows on its own line — no
hyphenation and no mid-word breaking. Spaces render verbatim as everywhere
else in this spec; the ones a break lands on stay with the line above and
hang past its end, so they never widen the paragraph.

Set \`wrap: false\` to opt a node out (buttons, badges): its glyphs then
ignore the resolved width and may overflow the slot.

A wrapped paragraph reports \`lineCount × lineHeight × fontSize\` for the
lines it actually broke into, so a Hug-height container around it sizes to
the wrapped text.

Export writes the solved constraint as \`bakedWrapWidth\` so players without
layout wrap at the same width. It is metres in the text node's local frame,
before TRS, and is omitted when wrapping is disabled or unconstrained. It
records the wrap width only: the slot, or a Hug \`maxWidth\` ceiling. It is
never the anchoring slot, so a player aligns anchored text to the text's
own box. Authoring clients ignore this bake, re-solve the retained
Layout/LayoutItem, and replace it on save. Export writes the bake for a Hug
\`maxWidth\` ceiling too, so a player that reads the bake needs nothing more.
A player uses a positive finite bake first, otherwise its own Fixed
LayoutItem width; \`wrap: false\` disables either constraint.

## Stroke / outline

\`strokeWidth\` is a fraction of em (\`0\` – \`0.05\`). At \`fontSize: 100\` this
range covers a 0–5 cm outline. The outline scales with \`fontSize\`, so
\`strokeWidth: 0.02\` looks the same proportional weight at small and large
sizes. Engines internally translate to whatever their renderer needs
(signed-distance offset, geometric stroke, etc.).

The upper bound of \`0.05\` reflects the analytic saturation point of an
MSDF field, not the visible result with any specific atlas. Each font
atlas's distance range determines the actual visible ceiling: the
bundled Roboto Regular (distance range 4 px) saturates around \`0.02\` —
values between \`0.02\` and \`0.05\` continue to mean what they mean
mathematically, but render the same as the saturation point. Higher-
resolution atlases in a future revision may extend the visible range;
the unit (em fraction) is fixed.

The outline fades with the text: \`opacity\` multiplies the alpha of
\`strokeColor\` exactly as it does the fill's, so at \`opacity: 0\` nothing of
the text is drawn, whether or not a stroke is set.

## Depth (extruded text)

\`depth\` gives the text a solid body behind its glyphs, \`depth\` em deep
(\`depth × fontSize / 100\` world units), so a title reads as an object
rather than a decal. \`0\` (the default)
is flat text. A value outside \`0\` – \`1\` (a bound one) clamps to that range.

The flat glyphs stay the face: they draw exactly as without \`depth\`, with
the same colour, stroke and opacity. The body is a closed solid of the same
outlines, filled by the non-zero rule, in the fill colour on a lit
material. Its walls carry the depth cue. Its front sits behind the glyph
plane (−Z in the node's frame) by 2% of the em, at most half a millimetre,
so the glyphs never z-fight it.

A stroked text's body follows its stroke: the outlines grow by the stroke
(round joins, as the outline draws), up to the widest stroke the face's
atlas can draw (half its distance range, 0.025 em for the bundled faces),
and the body takes \`strokeColor\`, so the outline continues down the walls.
Unstroked, the body is the glyphs' own outline in \`color\`.

\`depth\` does not move the text box: width, height, anchoring and wrapping
are as above, and layout gives the node the body's thickness, \`depth\` em
plus the set-back, from the data alone: a title with nothing to
outline (spaces) keeps its thickness and draws no body.

Export bakes the body to a plain glTF mesh, the node's \`src\`
(\`text3d_<key>.glb\`), so a player draws the Text it already draws and the
body as ordinary geometry: a client needs no extruder to show \`depth\`. An
authoring load drops the baked \`src\` and builds the body again from the
Text. This engine also builds it for a file that carries \`depth\` without a
bake. Only faces that carry glyph outlines (the bundled families) have a
body; a hosted family renders flat, with no thickness.

### Building the body

A player only draws the bake. An engine that authors \`depth\` builds the
same body like this (Babylon: \`behaviors/text/textBodyGeometry.ts\`; the
libraries it uses, Clipper2 and earcut, are C# originals or have C#
ports):

1. Lay the paragraph out as for the glyphs (advances, kerning, wrapping,
   anchoring), in the atlas's font units (\`info.size\` per em).
2. Take each glyph's outline from the face's outline file
   (\`assets/fonts/outlines/<face>.json\`: \`{ glyphs: { "<codepoint>":
   "<path>" } }\`, SVG-style \`M L Q C Z\` commands in font units, y up, from
   the pen position and the line top). A glyph laid out at \`(x, y)\` has its
   outline at \`(x + px, 1 − y + py)\`. A glyph with no entry has no body.
3. Flatten curves to within 1/1600 em, union the contours by the non-zero
   rule, and, for a stroked text, grow them by the stroke with round joins
   (capped as above).
4. Walls: a quad per boundary edge, from the front cap to the back cap, its
   normal outward; edges meeting at under 30° share a normal. Caps:
   each outline triangulated with its holes, facing +Z in front and −Z
   behind. Faces wind counter-clockwise seen from outside.
5. Scale font units to metres by \`fontSize / 100 / emSize\`, apply the
   anchor's y offset, and place the front cap at the set-back and the back
   cap \`depth × fontSize / 100\` behind it.
6. Material: lit PBR, metallic 0, roughness 0.6, base colour the body's
   colour above (linear), its alpha times \`opacity\`.

## Physical interpretation in scaled hierarchies

\`fontSize\` measures in the SceneObject's *local* coordinate system. When
a parent transform applies a non-identity scale, the rendered text scales
with it — \`fontSize: 14\` (~10 cm visible cap) inside a parent scaled by
0.5 renders at ~5 cm. This is the same property as every other world-unit
dimension in the scene graph: physical-unit interpretations are accurate
only when no ancestor scales the SceneObject. Layout integration in a
future revision may opt to override \`fontSize\` for fitted-text use cases;
in this RC, \`fontSize\` is always the intrinsic local-space size.

## Font model

Fonts are referenced by **family name** (\`fontFamily\`) plus weight and
style. Each engine ships its own atlas/asset for the supported families
— there is no portable atlas format in this RC.

**Families every engine carries (bundled):**

| Family                | Variants               | Role                              |
|-----------------------|------------------------|-----------------------------------|
| \`"Roboto"\`            | regular, bold × R/I    | Default sans-serif (8 of 8)       |
| \`"Inter"\`             | regular, bold × R/I    | UI-optimised sans-serif (8 of 8)  |
| \`"Source Serif 4"\`    | regular, bold × R/I    | Serif for long-form/formal text   |
| \`"JetBrains Mono"\`    | regular, bold × R/I    | Monospace for code/data/labels    |
| \`"Oswald"\`            | regular, bold (no I)   | Condensed display for distance    |
| \`"Bungee"\`            | regular only           | High-impact signage display       |
| \`"Caveat"\`            | regular, bold (no I)   | Casual handwriting / annotations  |

\`bold\` is one bundled face per family, not the whole 100–900 axis. A hosted
family publishes whichever upstream weight its designer treats as its bold,
so \`fontWeight: "bold"\` renders that family's own heavy rather than a
generic 700.

Families with partial coverage (Oswald, Caveat: no italics; Bungee: regular
only) participate in the standard fallback chain — requesting an unbundled
variant resolves to the family's nearest available face rather than a
synthesised oblique.

**Hosted families.** \`fontFamily\` also accepts a name outside the table
above, provided the deployment has registered a face for it before the
scene loads (Babylon: \`loadFontPack\` in \`behaviors/text/hostedFonts.ts\`,
fed by a font-pack manifest from the asset library). A hosted face
participates in the same fallback chain and is measured by the same rule as
a bundled one — its advance/kerning table is derived from the same BMFont
definition the renderer draws from.

An engine MUST NOT treat an unregistered name as a rendering error; it falls
back as above. Authoring tools MUST ask before emitting one — the family is
renderable iff the engine reports at least one variant for it.

## Conformance requirements

An engine implementing this spec MUST:

1. Read the font's **em-square size** and **natural line-height** from
   font metrics. \`fontSize\` interpretation depends on the em-square.
2. Support all values in the registry above for \`fontFamily\` /
   \`fontWeight\` / \`fontStyle\`. Unknown values fall back to the default
   family at the requested weight/style.
3. Render the text box anchored according to \`anchorX\` / \`anchorY\` with
   the SceneObject origin at the anchor point. For multi-line text, lines
   align horizontally according to \`anchorX\`.
4. Convert \`letterSpacing\` from em units to per-glyph advance offsets.
5. Convert \`strokeWidth\` from em fraction to a visually consistent
   outline at any \`fontSize\`.
6. Multiply \`opacity\` into the alpha of the fill and stroke colours:
   effective alpha = the colour's own alpha × \`opacity\`. Never replace the
   colour's alpha. Clamp to \`0\` – \`1\`; an absent, non-numeric or unresolved
   value is \`1\` (\`0\` is a real value).

A player that does not read \`opacity\` shows the text at its authored colour
alpha.

## Non-goals (RC)

Out of scope for this RC, reserved for future revisions: \`textAlign\`
(split horizontal-alignment from anchor when authors actually need it),
\`textTransform\`, \`wordBreak\` (hyphenation / mid-word breaking),
overflow/truncation/ellipsis
(\`maxLines\`), RTL / bidi \`direction\`, rich-text spans (mixed colours/sizes
within one Text), non-Latin scripts (CJK, Arabic, Devanagari) — these are
atlas-prohibitive for MSDF and want a separate strategy. Layout-driven
fontSize override (e.g. \`fitToWidth\`) is also reserved for the Layout RC.
Weights beyond \`regular\`/\`bold\` are reserved: hosting makes further slots
cheap for the first time, but widening the axis changes every existing
scene's resolution chain.

## References

- CSS \`font-size\`, \`text-align\`, \`letter-spacing\`, \`line-height\`
- Microsoft MR text guidelines:
  https://learn.microsoft.com/en-us/windows/mixed-reality/develop/unity/text-in-unity
- troika-three-text — closest analogue in the WebXR ecosystem`,
    fields: [
      {
        key: "text",
        type: "string",
        label: "Text",
        default: "Text",
        description: "Text content to display. Use `\\n` for explicit line breaks.",
        format: "multiline"
      },
      {
        key: "fontFamily",
        type: "enum",
        label: "Font Family",
        options: [
          "Roboto",
          "Inter",
          "Source Serif 4",
          "JetBrains Mono",
          "Oswald",
          "Bungee",
          "Caveat"
        ],
        openEnum: !0,
        default: "Roboto",
        description: `Font family name. One of the bundled families listed in this
behavior's docs, or the name of a family the deployment has registered
from a hosted font pack. Unregistered names, or available names with
missing weight/style combinations, fall back along the chain
\`style → weight → family → default family at the requested
weight/style → default\`.

Display families that ship without italics (Oswald, Caveat) or as
single-weight only (Bungee) participate in the same fallback —
authoring \`fontFamily: "Oswald", fontStyle: "italic"\` resolves to
Oswald Regular, not a synthesised oblique.`
      },
      {
        key: "fontWeight",
        type: "enum",
        label: "Font Weight",
        options: ["regular", "bold"],
        default: "regular",
        description: "Font weight."
      },
      {
        key: "fontStyle",
        type: "enum",
        label: "Font Style",
        options: ["normal", "italic"],
        default: "normal",
        description: "Font style."
      },
      {
        key: "fontSize",
        type: "number",
        label: "Font Size",
        default: 14,
        step: 1,
        description: "Font size, measured as the em-square in centi-world-units.\n`100` = 1 world-unit em-square. See sizing reference above."
      },
      {
        key: "color",
        type: "color",
        label: "Color",
        default: "#FFFFFF",
        description: "Fill colour, hex `#RRGGBB` or `#RRGGBBAA`."
      },
      {
        key: "opacity",
        type: "number",
        label: "Opacity",
        hidden: !0,
        step: 0.01,
        min: 0,
        max: 1,
        description: "Opacity of the whole text, `0` (invisible) to `1` (opaque), independent\nof `color`. Multiplies into the alpha of `color` and `strokeColor`, so it\nworks over a style-bound colour and can be bound to a property to differ\nper state or page. Absent means `1`.",
        optional: !0
      },
      {
        key: "strokeColor",
        type: "color",
        label: "Stroke Color",
        description: "Outline colour. Has no effect unless `strokeWidth > 0`.",
        optional: !0
      },
      {
        key: "strokeWidth",
        type: "number",
        label: "Stroke Width",
        default: 0,
        step: 5e-3,
        min: 0,
        max: 0.05,
        description: "Outline thickness as a fraction of em. `0` = no outline,\n`0.01` = subtle, `0.02` = readable on busy backgrounds.\nVisually consistent across `fontSize`. Visible saturation depends\non the loaded font atlas — the bundled Roboto saturates around\n`0.02`; higher-resolution atlases extend further."
      },
      {
        key: "depth",
        type: "number",
        label: "Depth",
        default: 0,
        step: 0.01,
        min: 0,
        max: 1,
        description: 'Extrusion depth behind the glyphs, in em (fraction of `fontSize`).\n`0` is flat text; `0.08` is a solid display title. See "Depth" above.'
      },
      {
        key: "anchorX",
        type: "enum",
        label: "Anchor X",
        options: [
          "left",
          "center",
          "right"
        ],
        default: "center",
        description: `Horizontal anchor of the text box relative to the SceneObject origin.
Also controls line alignment for multi-line text:
\`left\` aligns lines flush-left with the origin at the left edge,
\`center\` centres lines with the origin at the horizontal centre,
\`right\` aligns lines flush-right with the origin at the right edge.

**Which box.** Inside a layout, the box this anchors is the node's
resolved SLOT, not the glyph run: \`left\` puts the paragraph at the
slot's left edge however wide the slot is, and \`right\` at its right
edge. An engine that anchors the run instead centres a left-anchored
paragraph in a wide slot, which is neither alignment. Where the layout
resolved no width — standalone text, or a Hug width that is the text's
own measurement — the box IS the run and the two agree. A Hug
\`maxWidth\` ceiling limits wrapping but is not a slot, so it does not
move short anchored text. \`center\` is the
same answer either way, which is why the default is unaffected.`
      },
      {
        key: "anchorY",
        type: "enum",
        label: "Anchor Y",
        options: [
          "top",
          "middle",
          "bottom"
        ],
        default: "middle",
        description: "Vertical anchor of the text box relative to the SceneObject origin.\n`top` puts the origin at the first line's cap line; `middle` at the\nvertical centre of the box; `bottom` at the bottom of the last line."
      },
      {
        key: "lineHeight",
        type: "number",
        label: "Line Height",
        default: 1.2,
        step: 0.1,
        description: "Line spacing as a multiplier of em-square (CSS `line-height` model).\n`1.0` = one em of vertical advance per line (tight); `1.2` is the\ntypical default for body text; `1.5` is comfortably spaced.\n\nNote: this is em-relative, not relative to the font's intrinsic\n`common.lineHeight` — that internal metric varies by ~10–30%\nacross fonts, which would make `lineHeight: 1.0` produce\ndifferent visual spacing for the same authored value across\nfamilies."
      },
      {
        key: "letterSpacing",
        type: "number",
        label: "Letter Spacing",
        default: 0,
        step: 0.01,
        description: "Letter spacing in em units (fraction of `fontSize` em-square).\n`0` is the font's default tracking, `0.05` is subtle wide-tracking,\nnegative values tighten."
      },
      {
        key: "wrap",
        type: "boolean",
        label: "Wrap",
        default: !0,
        description: `Whether a layout-resolved width wraps this paragraph (see "Wrapping &
sizing" above). The width comes from a container's solve, or — with no
container above the node — from its own \`LayoutItem\`'s Fixed width
(tv#709) or a Hug \`maxWidth\` ceiling: "text bounds" is a LayoutItem
either way, and there is deliberately no authored \`maxWidth\` on Text.
Disable for single-line UI text (buttons, badges) that should overflow
its slot rather than break.`
      },
      {
        key: "bakedWrapWidth",
        type: "number",
        label: "Baked Wrap Width",
        hidden: !0,
        description: `Exported wrap constraint in metres, before node/ancestor transforms.
Output only: authoring uses Layout/LayoutItem and replaces this on save.
Contract: https://github.com/TraceXR/trace-viewer/issues/1021`,
        optional: !0
      }
    ]
  },
  {
    type: "Timeline",
    description: "Controls a unified scene timeline that coordinates playable behaviors.\n\nDrives every Playable (Animation, AudioClip, Video, …) on this object and\nits descendants at any depth. Optionally follows a media master clock\n(`clock`), and applies `active` state cues from `keyframes`. Keyframe\nanimations the timeline starts (play, seek, loop) are sampled at its time\nevery frame — they follow it and its master clock exactly, and advance at\ntimeline `speed` × their own — until something else plays them; media run\non their own clock and are re-seeked on play, seek, loop and snap.\n\nRuntime control: use the `play` / `pause` / `seek` actions (via `call_action`)\nto control playback. Editing `playOnStart` only affects the next load and does\nNOT pause a running timeline.",
    fields: [
      {
        key: "duration",
        type: "number",
        label: "Duration",
        default: 10,
        step: 0.1,
        min: 0,
        description: "Total duration in seconds"
      },
      {
        key: "loop",
        type: "boolean",
        label: "Loop",
        default: !1,
        description: "Whether to loop playback"
      },
      {
        key: "speed",
        type: "number",
        label: "Speed",
        default: 1,
        step: 0.1,
        min: 0,
        description: "Playback speed multiplier"
      },
      {
        key: "playOnStart",
        type: "boolean",
        label: "Play On Start",
        default: !0,
        description: "Whether to auto-play when entering play mode"
      },
      {
        key: "clock",
        type: "string",
        label: "Clock",
        description: `Master clock: path (relative to this object) to a node carrying a
clock-capable Playable — AudioClip or Video. While playing at
\`speed\` 1, the timeline follows that medium's clock: it snaps to it
when more than 0.25 s apart and otherwise slews toward it (so coarse
media time does not jitter), and advances on scene time whenever the
medium is not producing time (not loaded, buffering, before its
\`startAt\`). The medium is seeked with every other Playable on play,
seek and loop, but never re-seeked during play; when the timeline
snaps, the OTHER Playables are re-seeked to follow it. Ignored when
\`speed\` ≠ 1 (media play at their own rate). Unset: scene time only.`,
        optional: !0
      }
    ],
    actions: [
      {
        name: "play",
        label: "Start or resume playback"
      },
      {
        name: "pause",
        label: "Pause playback (retains current time)"
      },
      {
        name: "seek",
        label: 'Seek to a time in seconds. Args: (time, mode?) where mode is "absolute" (default) or "relative" — "relative" adds the delta to the current time, so seek(2, "relative") jumps 2s forward and seek(-2, "relative") jumps 2s back.'
      }
    ]
  },
  {
    type: "Video",
    description: "Controls video playback settings",
    fields: [
      {
        key: "playOnStart",
        type: "boolean",
        label: "Play On Start",
        default: !0,
        description: "Whether to automatically play video on scene start"
      },
      {
        key: "userInteractible",
        type: "boolean",
        label: "User Interactible",
        default: !1,
        description: "Whether user can interact with video controls"
      },
      {
        key: "controls",
        type: "boolean",
        label: "Controls",
        default: !1,
        description: `Shows playback controls (i.e. timeline)
Also enables userInteractible (tap to play)`
      },
      {
        key: "loop",
        type: "boolean",
        label: "Loop",
        default: !0,
        description: "Whether to loop video playback"
      },
      {
        key: "aspect",
        type: "number",
        label: "Aspect",
        step: 0.01,
        description: "Video aspect ratio (width/height).",
        optional: !0
      },
      {
        key: "orientation",
        type: "enum",
        label: "Orientation",
        options: ["Horizontal", "Vertical"],
        default: "Vertical",
        description: "Video orientation"
      },
      {
        key: "fit",
        type: "enum",
        label: "Fit",
        options: ["contain", "cover"],
        default: "contain",
        description: `How the video meets a box whose aspect differs from its own.

\`contain\` (the default) letterboxes: the plane shrinks on one axis so
the whole frame stays visible inside the box, never distorted.

\`cover\` fills: the plane spans the box exactly and a centered window
of the frame is shown instead, cropping the overflowing axis. The
crop is a view, not an edit — switching back to \`contain\` shows the
full frame again.

Absent means \`contain\`: exactly the fit scenes have always had.`
      },
      {
        key: "cornerRadius",
        type: "number",
        label: "Corner Radius",
        default: 0,
        step: 1e-3,
        min: 0,
        description: `Corner radius in meters (the unit MeshBackground's cornerRadius
uses; measured here on the CURRENT visible media rectangle - a
media quad has no rest box). One value gives differently sized
frames identical corners, and a resized frame keeps its corner
size. Never larger than half the rectangle's current smaller side
- an oversized value degrades to a pill instead of self-crossing.

Rounds the media quad itself, which neither Bevel (its host gate
takes only builtin primitives) nor MeshBackground (drives the
library rigs' authored morphs) can reach. Composes with \`fit\`: the
corners round the letterboxed rectangle under \`contain\`, the full
box under \`cover\`. Strictly geometry: paint stays on Renderer,
sizing stays on the transform; clients without a corner-radius
implementation render the sharp rectangle - content intact.`
      },
      {
        key: "pill",
        type: "boolean",
        label: "Pill",
        default: !1,
        description: `Round the quad to half its smaller side — a capsule at any size,
which is the one shape an absolute radius cannot name. Overrides
\`cornerRadius\` when true. Same vocabulary as Bevel and
MeshBackground (#759).`
      },
      {
        key: "back",
        type: "enum",
        label: "Back",
        options: [
          "none",
          "picture",
          "color"
        ],
        default: "none",
        description: "What the quad's back shows. `none` culls it: nothing is drawn behind\nthe picture. `picture` renders the media on both faces of the one\nquad - seen from behind it reads mirrored, as a print does through\nits paper (a two-sided quad; glTF's doubleSided idea, NOT a second\nreadable surface). `color` backs the picture with a flat unlit\n`backColor` card that also shows through transparent pixels from the\nfront. A GLB export carries what the object shows: `picture` as the\ndoubled quad, `color` as a second mesh named `<quad>_back`."
      },
      {
        key: "backColor",
        type: "color",
        label: "Back Color",
        default: "#FFFFFF",
        description: "The card color behind the picture when `back` is `color`\n(#RRGGBB or #RRGGBBAA - the alpha rides the string). Ignored for\nthe other values."
      }
    ],
    actions: [
      {
        name: "play",
        label: "Play the video"
      },
      {
        name: "pause",
        label: "Pause the video"
      },
      {
        name: "stop",
        label: "Stop playback and reset to the beginning"
      },
      {
        name: "seek",
        label: 'Seek to a time in seconds. Args: (time, mode?) where mode is "absolute" (default) or "relative" — "relative" adds the delta to the current time, so seek(2, "relative") jumps 2s forward and seek(-2, "relative") jumps 2s back.'
      },
      {
        name: "setVolume",
        label: "Set video volume, 0-1 (takes volume argument)"
      }
    ]
  },
  {
    type: "ViewAnchor",
    description: `Keeps an object anchored at a gaze-frame offset from the user or an
anchor object`,
    fields: [
      {
        key: "enabled",
        type: "boolean",
        label: "Enabled",
        default: !0,
        description: `Whether view anchoring is active when play mode starts. When false the
object stays put until the behavior graph enables it
(trace/setBehaviorEnabled). Disabling at runtime stops it where it is;
re-enabling re-runs \`delay\`. Every play-mode start resets to this value.`
      },
      {
        key: "target",
        type: "string",
        label: "Target",
        default: "",
        description: `Optional anchor: a TransformPath to another scene object whose position
and world +Z define the gaze frame, or empty to anchor to the user (the
active camera and its gaze).`
      },
      {
        key: "forward",
        type: "number",
        label: "Forward",
        default: 1,
        description: `How far in front the object rests — meters along the gaze frame's
forward.`
      },
      {
        key: "lateral",
        type: "number",
        label: "Lateral",
        default: 0,
        description: `Meters to the right of the gaze (negative = left) — side-docked panels.
The lateral axis stays horizontal, so gaze tilt never rolls the offset.`
      },
      {
        key: "vertical",
        type: "number",
        label: "Vertical",
        default: 0,
        description: "World-up offset of the goal in meters (negative = below the eye line)."
      },
      {
        key: "viewAngle",
        type: "number",
        label: "View Angle",
        default: 20,
        description: `Angular dead zone in degrees, measured at the anchor between the object
and its goal — small head turns don't move it, and off-axis goals
(lateral/vertical offsets) keep their full dead zone. 180 never
recenters for drift (walking away still catches up); compose with
Enable Behavior for a pure one-shot summon.`
      },
      {
        key: "axes",
        type: "multiSelect",
        label: "Axes",
        options: [
          "x",
          "y",
          "z"
        ],
        description: `World axes the object may move along. Omit for all three. ["x","z"]
keeps the authored height while recentering left/right and near/far.`,
        optional: !0
      },
      {
        key: "speed",
        type: "number",
        label: "Speed",
        default: 1.5,
        description: "Maximum movement speed in meters per second."
      },
      {
        key: "damping",
        type: "number",
        label: "Damping",
        default: 0.25,
        description: `Movement smoothing as a time constant in seconds — larger trails more
softly (arrival eases in). 0 moves linearly at full speed.`
      },
      {
        key: "delay",
        type: "number",
        label: "Delay",
        default: 0,
        description: `Seconds the trigger condition must hold before the object starts
moving — the natural "notice, then recenter" feel.`
      }
    ]
  }
], _e = Object.fromEntries(fe.map((o) => [o.type, o]));
function Re(o) {
  return _e[o];
}
function rt() {
  return fe.filter((o) => Be(o.type) !== void 0).map((o) => o.type);
}
function ye(o) {
  const t = {};
  for (const e of o) if (e.default !== void 0) t[e.key] = structuredClone(e.default);
  else if (e.type === "object" && e.isMap)
    e.optional || (t[e.key] = {});
  else if (e.type === "object") {
    const n = ye(e.fields);
    Object.keys(n).length > 0 && (t[e.key] = n);
  }
  return t;
}
function Oe(o, t) {
  const e = Re(o), n = { "@type": o };
  if (e) {
    const i = ye(e.fields);
    Object.assign(n, i);
  }
  if (t)
    for (const [i, a] of Object.entries(t)) a !== void 0 && (n[i] = a);
  return n;
}
var De = "builtin:", O = {
  cube: "primitive_cube.glb",
  sphere: "primitive_sphere.glb",
  plane: "primitive_plane.glb",
  cylinder: "primitive_cylinder.glb"
};
function ge(o) {
  return o?.startsWith("builtin:") ?? !1;
}
function be(o) {
  if (!ge(o)) return null;
  const t = o.substring(8);
  for (const [e, n] of Object.entries(O)) if (t === n) return e;
  return null;
}
function ee(o) {
  const t = be(o);
  if (t) return t;
  for (const [e, n] of Object.entries(O)) if (o === `./assets/${n}` || o === `assets/${n}`) return e;
  return null;
}
function lt(o) {
  return `${De}${O[o]}`;
}
function Le(o) {
  return `./assets/${O[o]}`;
}
var G = (o) => Object.freeze({
  ...o,
  options: Object.freeze({ ...o.options })
}), Pe = Object.freeze({
  cube: G({
    builder: "CreateBox",
    options: { size: 1 }
  }),
  sphere: G({
    builder: "CreateSphere",
    options: {
      diameter: 1,
      segments: 32
    }
  }),
  plane: G({
    builder: "CreatePlane",
    options: { size: 1 },
    rotateX: 90
  }),
  cylinder: G({
    builder: "CreateCylinder",
    options: {
      height: 1,
      diameter: 1,
      tessellation: 32
    }
  })
});
function ve(o, t, e) {
  const { builder: n, options: i, rotateX: a } = Pe[o], r = Me[n](e ?? `__builtin_${o}__`, { ...i }, t);
  return a !== void 0 && (r.rotation.x = a * Math.PI / 180, r.bakeCurrentTransformIntoVertices()), r;
}
function dt(o, t, e) {
  const n = ve(o, t, `${e}_mesh`), i = new Q(`${e}_material`, t);
  return i.albedoColor = new J(0.8, 0.8, 0.8), i.metallic = 0, i.roughness = 0.5, n.material = i, n;
}
async function ct(o, t) {
  const e = new pe(t.getEngine());
  e.useRightHandedSystem = t.useRightHandedSystem;
  try {
    const n = ve(o, e), i = new Q(`__builtin_${o}_material__`, e);
    i.albedoColor = new J(0.8, 0.8, 0.8), i.metallic = 0, i.roughness = 0.5, n.material = i;
    const a = (await ue.GLBAsync(e, O[o].replace(".glb", ""), {
      shouldExportNode: (r) => r === n,
      exportWithoutWaitingForScene: !0,
      exportUnusedUVs: !0
    })).glTFFiles[`${O[o].replace(".glb", "")}.glb`];
    return a instanceof Blob ? a : new Blob([a], { type: "model/gltf-binary" });
  } finally {
    e.dispose();
  }
}
async function ht(o, t, e, n = {}) {
  const i = new pe(e.getEngine());
  i.useRightHandedSystem = e.useRightHandedSystem;
  try {
    const a = new Ie(t, i);
    if (o.applyToMesh(a), n.material) a.material = n.material(i);
    else {
      const s = new Q(`${t}_material`, i);
      s.albedoColor = new J(0.8, 0.8, 0.8), s.metallic = 0, s.roughness = 0.5, a.material = s;
    }
    const r = (await ue.GLBAsync(i, t, {
      shouldExportNode: (s) => s === a,
      exportWithoutWaitingForScene: !0,
      exportUnusedUVs: !0
    })).glTFFiles[`${t}.glb`];
    return r instanceof Blob ? r : new Blob([r], { type: "model/gltf-binary" });
  } finally {
    i.dispose();
  }
}
function pt(o) {
  const t = /* @__PURE__ */ new Set(), e = (n) => {
    if (!n || typeof n != "object") return;
    const i = n;
    if (typeof i.src == "string") {
      const a = ee(i.src);
      a && t.add(a);
    }
    for (const a in i) if (Object.hasOwn(i, a)) {
      const r = i[a];
      typeof r == "object" && e(r);
    }
  };
  return o.forEach((n) => e(n)), t;
}
function ut(o) {
  const t = new Map(Object.entries(Oe("Model"))), e = (n) => {
    const i = Object.entries(n);
    return i.length === t.size && i.every(([a, r]) => t.get(a) === r);
  };
  for (const n of o)
    !n.src || !ee(n.src) || !n.behaviors || (n.behaviors = n.behaviors.filter((i) => !e(i)));
}
function mt(o) {
  const t = (e) => {
    if (!e || typeof e != "object") return;
    const n = e;
    if (typeof n.src == "string" && ge(n.src)) {
      const i = be(n.src);
      if (i) {
        const a = Le(i);
        R.log(`[BuiltInPrimitives] Rewriting src: ${n.src} -> ${a}`), n.src = a;
      }
    }
    for (const i in n) if (Object.hasOwn(n, i)) {
      const a = n[i];
      typeof a == "object" && t(a);
    }
  };
  o.forEach((e) => t(e));
}
var A = class w extends ce {
  static behaviorType = "LayoutItem";
  static nearestLayoutAuthority(t) {
    let e = t;
    for (; e; ) {
      const n = e.getBehavior("Layout");
      if (n) return n;
      e = e.getParent();
    }
    return null;
  }
  static hasNoLayoutAuthority(t) {
    return w.nearestLayoutAuthority(t) === null;
  }
  static standaloneWidth(t) {
    return w._standaloneFeed(t).width;
  }
  static hugCeiling(t) {
    return typeof t == "number" && Number.isFinite(t) && t > 0 ? t : null;
  }
  static _standaloneFeed(t) {
    const e = {
      width: null,
      slot: null
    }, n = t.getBehavior(w);
    if (!n || n._detaching) return e;
    const i = n._getResolvedData();
    return i.widthMode === "Hug" ? {
      width: w.hugCeiling(i.maxWidth),
      slot: null
    } : i.widthMode !== "Fixed" || typeof i.width != "number" ? e : {
      width: i.width,
      slot: i.width
    };
  }
  static feedStandaloneWidth(t, e = !1) {
    if (!e && !w.hasNoLayoutAuthority(t)) return;
    const { width: n, slot: i } = w._standaloneFeed(t);
    w._pushWidth(t, n, i);
  }
  static _pushWidth(t, e, n) {
    for (const i of t.getBehaviors()) i.setLayoutResolvedWidth?.(e, n);
  }
  onAttach() {
    w._installReparentHook(this.sceneObject.traceScene), this._notifyParentLayout();
  }
  async applyCommit(t, e) {
    this._notifyParentLayout({ authored: e !== this.getAuthored() });
  }
  static _reparentHooked = /* @__PURE__ */ new WeakSet();
  static _installReparentHook(t) {
    !t || typeof t.onObjectReparented != "function" || w._reparentHooked.has(t) || (w._reparentHooked.add(t), t.onObjectReparented((e) => {
      for (const n of [e, ...e.getDescendants()])
        n.transform.isDisposed() || n.getBehavior(w) && w.feedStandaloneWidth(n);
    }));
  }
  _detaching = !1;
  _warnedNoWidth = !1;
  onDetach() {
    this._detaching = !0, w.feedStandaloneWidth(this.sceneObject), this._invalidateAncestorLayout();
  }
  _invalidateAncestorLayout(t = {}) {
    let e = this.sceneObject.getParent();
    for (; e; ) {
      const n = e.getBehavior("Layout");
      if (n)
        return n.invalidate(t), !0;
      e = e.getParent();
    }
    return !1;
  }
  _notifyParentLayout(t = {}) {
    if (this._invalidateAncestorLayout(t)) {
      this._warnedNoWidth = !1;
      return;
    }
    if (this.sceneObject.getBehavior("Layout")) {
      this._warnedNoWidth = !1;
      return;
    }
    w.feedStandaloneWidth(this.sceneObject, !0);
    const e = this.sceneObject.getBehaviors().some((n) => typeof n.setLayoutResolvedWidth == "function");
    if (w.standaloneWidth(this.sceneObject) !== null && (e || this._getResolvedData().widthMode === "Fixed")) {
      this._warnedNoWidth = !1;
      return;
    }
    this._warnedNoWidth || (this._warnedNoWidth = !0, R.warn(`[LayoutItem] "${this.sceneObject.name}" has a LayoutItem with neither a Fixed width nor a Hug maxWidth, and no ancestor Layout — nothing sizes it.`));
  }
}, q = class {
  layoutContentFrame = "parent";
  layoutFit = "none";
  constructor(o) {
    this.object = o;
  }
  getLayoutContentSize() {
    return this.measure("parent")?.size ?? null;
  }
  getLayoutContentCenter() {
    return this.measure("parent")?.center ?? null;
  }
  getLayoutIntrinsicSize() {
    return this.measure("intrinsic")?.size ?? null;
  }
  watchBounds(o) {
    const t = o.intrinsic ? "intrinsic" : "parent", e = this.measure(t);
    return () => {
      const n = this.measure(t);
      return !e || !n ? e !== n : ["size", "center"].some((i) => [
        "x",
        "y",
        "z"
      ].some((a) => Math.abs(e[i][a] - n[i][a]) > o.epsilon));
    };
  }
  includes(o) {
    if (!o.isVisible || o.visibility <= 0 || !o.isEnabled() || o.infiniteDistance || o.getTotalVertices() === 0) return !1;
    const t = o.name;
    if (t.startsWith("__") && !t.startsWith("__builtin_") || t.endsWith("__collider") || t.endsWith("__selection")) return !1;
    for (let e = o; e; e = e.parent) {
      const n = e.metadata;
      if (e.doNotSerialize || n?.editorOnly || n?.editorHandle || n?.doNotSerialize || n?.hidden) return !1;
    }
    return !0;
  }
  measure(o) {
    const t = this.object.transform, e = (o === "intrinsic" ? t : t.parent)?.computeWorldMatrix(!0) ?? P.Identity();
    if (e.determinant() === 0) return null;
    let n = P.Invert(e);
    if (o === "intrinsic") {
      const c = t.rotationQuaternion ?? he.FromEulerVector(t.rotation);
      n = n.multiply(P.Compose(m.One(), c, m.Zero()));
    }
    const i = new m(1 / 0, 1 / 0, 1 / 0), a = new m(-1 / 0, -1 / 0, -1 / 0), r = new m();
    for (const c of t.getChildMeshes(!1))
      if (this.includes(c)) {
        c.computeWorldMatrix(!0);
        for (const l of c.getBoundingInfo().boundingBox.vectorsWorld)
          m.TransformCoordinatesToRef(l, n, r), i.minimizeInPlace(r), a.maximizeInPlace(r);
      }
    const s = {
      x: a.x - i.x,
      y: a.y - i.y,
      z: a.z - i.z
    };
    if (!Object.values(s).every((c) => Number.isFinite(c) && c >= 0)) return null;
    const d = o === "parent" ? t.position : m.Zero();
    return {
      size: s,
      center: {
        x: (i.x + a.x) / 2 - d.x,
        y: (i.y + a.y) / 2 - d.y,
        z: (i.z + a.z) / 2 - d.z
      }
    };
  }
}, oe = 1e4, se = 1e-6;
function Ee(o, t, e, n, i) {
  const a = [
    "x",
    "y",
    "z"
  ], r = {};
  for (const l of a)
    n[l] !== "Hug" && (n[l] === "Fixed" && e[l] < i[l] - 1e-6 || e[l] <= se || t[l] <= se || (r[l] = e[l] / t[l]));
  const s = a.filter((l) => r[l] !== void 0);
  if (s.length === 0) return null;
  if (o === "fill") return {
    x: r.x ?? 1,
    y: r.y ?? 1,
    z: r.z ?? 1
  };
  const d = s.map((l) => r[l]);
  let c = o === "cover" ? Math.max(...d) : Math.min(...d);
  return o === "scale-down" && (c = Math.min(c, 1)), {
    x: c,
    y: c,
    z: c
  };
}
function re(o) {
  return o.rotationQuaternion ?? he.FromEulerVector(o.rotation);
}
function We(o) {
  return typeof o == "object" && o !== null && "getLayoutContentSize" in o && typeof o.getLayoutContentSize == "function" && o.providesLayoutSize !== !1;
}
function je(o) {
  const t = [];
  for (const n of o.getBehaviors()) We(n) && t.push(n);
  const e = t.length < 2 ? t : [...t.filter((n) => n.layoutFit !== "none"), ...t.filter((n) => n.layoutFit === "none")];
  return o.getBehavior(A)?._getResolvedData().measureGeometry === !0 && !o.getBehavior(ke) && !o.getBehaviors().some($) ? [new q(o), ...e] : e;
}
function $(o) {
  return typeof o == "object" && o !== null && "setResolvedSize" in o && typeof o.setResolvedSize == "function";
}
function le(o) {
  return typeof o == "object" && o !== null && "layoutContentFit" in o;
}
var de = /* @__PURE__ */ new WeakSet(), we = 1, T = 1e-3, Z = 3;
function He(o, t, e, n, i, a, r) {
  e && o.set(t, {
    parent: e,
    parentSize: { ...n },
    slotCenter: i,
    slotSize: { ...a },
    position: {
      x: r.x,
      y: r.y,
      z: r.z
    }
  });
}
var ke = class f extends ce {
  static behaviorType = "Layout";
  _engine = new Ce();
  _isComputingLayout = !1;
  _batchScheduled = !1;
  _geometryPasses = 0;
  _hasGeometry = !1;
  _providers = /* @__PURE__ */ new Map();
  _solvedPlacements = null;
  static _observedScenes = /* @__PURE__ */ new WeakSet();
  static observeSolves(t, e) {
    e ? f._observedScenes.add(t) : f._observedScenes.delete(t);
  }
  getSolvedPlacement(t) {
    const e = this._findLayoutRoot().getBehavior(f), n = e?._solvedPlacements?.get(t);
    return !e || e._batchScheduled || e._isComputingLayout || !n || t.getParent() !== n.parent || t.transform.isDisposed() ? null : {
      parent: n.parent,
      parentSize: { ...n.parentSize },
      slotCenter: { ...n.slotCenter },
      slotSize: { ...n.slotSize },
      position: { ...n.position }
    };
  }
  _fedReceivers = /* @__PURE__ */ new Set();
  _fedWidthProviders = /* @__PURE__ */ new Map();
  _flowedAsAuto = /* @__PURE__ */ new Map();
  _managedFields = /* @__PURE__ */ new Map();
  _heldCenters = /* @__PURE__ */ new Map();
  _solvedSize = null;
  getSolvedSize() {
    return this._solvedSize && { ...this._solvedSize };
  }
  onAttach() {
    f._installReparentHook(this.sceneObject.traceScene), this._markDirty();
  }
  onDetach() {
    this._patienceTimer !== null && (clearTimeout(this._patienceTimer), this._patienceTimer = null), this._releaseAll();
    const t = this._findLayoutRoot().getBehavior(f);
    if (t && t !== this) {
      t._scheduleBatch();
      return;
    }
    const e = [...this.sceneObject.getChildren()];
    for (; e.length > 0; ) {
      const n = e.pop(), i = n.getBehavior(f);
      if (!i) {
        e.push(...n.getChildren());
        continue;
      }
      queueMicrotask(() => {
        !n.transform.isDisposed() && n.getBehavior(f) === i && i._scheduleBatch();
      });
    }
  }
  _releaseAll() {
    this._solvedPlacements = null;
    for (const t of this._fedReceivers) t.clearResolvedSize?.();
    this._fedReceivers.clear();
    for (const { owner: t } of this._fedWidthProviders.values())
      t.transform.isDisposed() || this._ownsDeparture(t) && A.feedStandaloneWidth(t, !0);
    this._fedWidthProviders.clear(), this._flowedAsAuto.clear();
    for (const t of this._managedFields.keys()) t.setRuntimeTransformFieldOwner(this, {
      position: !1,
      scale: !1
    });
    this._managedFields.clear();
  }
  async applyCommit(t, e) {
    e !== this.getAuthored() && this._restartGeometryBudget(), this._markDirty();
  }
  invalidate(t = {}) {
    t.authored && this._restartGeometryBudget(), this._markDirty();
  }
  _restartGeometryBudget() {
    const t = this._findLayoutRoot().getBehavior(f);
    t && !t._isComputingLayout && (t._geometryPasses = 0);
  }
  static isFitted(t) {
    for (let e = t.getParent(); e; e = e.getParent()) if (e.getBehavior(f)?._managedFields.get(t)?.fitted) return !0;
    return !1;
  }
  _markDirty() {
    const t = this._findLayoutRoot().getBehavior(f);
    t && t._scheduleBatch();
  }
  _geometryTopology = "";
  _geometryTopologyKey() {
    return JSON.stringify([this.sceneObject, ...this.sceneObject.getDescendants()].map((t) => [t.getPath(), t.getBehaviors().map((e) => e.name)]));
  }
  _scheduleBatch() {
    if (this._hasGeometry && this._geometryPasses >= Z) {
      if (this._geometryTopologyKey() === this._geometryTopology) return;
      this._geometryPasses = 0;
    }
    this._batchScheduled || (this._batchScheduled = !0, queueMicrotask(() => {
      this._batchScheduled = !1;
      try {
        this._runLayout();
      } catch (t) {
        R.error(`[Layout] Layout pass failed on "${this.sceneObject.name}" (node ${this.sceneObject.transform.uniqueId}) — skipping this pass: ` + (t instanceof Error ? t.message : String(t)));
      }
    }));
  }
  _runLayout() {
    if (this._isComputingLayout) return;
    let t = [];
    this._solvedPlacements = null, this._hasGeometry = !1, this._isComputingLayout = !0;
    try {
      const e = new Te(), n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
      if (this._nextDeadline = 1 / 0, this._heldCenters.clear(), this._providers.clear(), this._buildTree(this.sceneObject, e, null, n, i, a), e.getAllNodes().length <= 1) {
        this._releaseAll(), this._solvedSize = null;
        return;
      }
      this._engine.setIntrinsicProvider({
        getIntrinsicSize: (d) => this._getIntrinsicSize(d, n, e, i),
        getMinSize: () => ({
          x: 0,
          y: 0,
          z: 0
        })
      });
      const r = this._watchGeometry(e, n);
      this._hasGeometry = r.length > 0, this._hasGeometry && (this._geometryTopology = this._geometryTopologyKey()), this._hasGeometry && this._geometryPasses++, this._engine.computeLayout(e);
      const s = this._collectDeferred(e, a);
      this._applyResults(e, n, i, s), r.some((d) => d()) ? this._geometryPasses < Z ? this._scheduleBatch() : R.warn(`[Layout] Geometry on "${this.sceneObject.name}" did not settle after ${Z} passes.`) : this._geometryPasses = 0, t = this._bakeContainerSizes(e, n, s);
    } catch (e) {
      throw this._hasGeometry = !1, e;
    } finally {
      this._isComputingLayout = !1, this._providers.clear(), this._armPatience();
    }
    for (const e of t) this.sceneObject.traceScene._emitLayoutSizeBaked?.(e);
    this.sceneObject.traceScene._emitLayoutSolved?.(this.sceneObject);
  }
  _bakeContainerSizes(t, e, n) {
    const i = [];
    return t.traverse((a) => {
      const r = e.get(a.id), s = r?.getBehavior(f);
      if (!r || !s || (s._solvedSize = { ...a.resolvedSize }, n.has(a.id))) return;
      const d = s._resolved, c = a.resolvedSize;
      let l = !1;
      d.widthMode === "Hug" && (l = f._bakeAxis(s, "width", c.x) || l), d.heightMode === "Hug" && (l = f._bakeAxis(s, "height", c.y) || l), d.depthMode === "Hug" && (l = f._bakeAxis(s, "depth", c.z) || l), l && i.push(r);
    }), i;
  }
  static _bakeAxis(t, e, n) {
    const i = t.getAuthored();
    if (typeof i[e] == "string") return !1;
    const a = t._resolved[e];
    return typeof a == "number" && Math.abs(a - n) < 1e-6 ? !1 : (i[e] = n, t._resolved[e] = n, !0);
  }
  _getProviders(t) {
    let e = this._providers.get(t);
    if (!e) {
      e = je(t);
      const n = e[0];
      n instanceof q && !n.getLayoutContentSize() && (e = e.slice(1)), this._providers.set(t, e);
    }
    return e;
  }
  _watchGeometry(t, e) {
    const n = [];
    for (const i of t.getAllNodes()) {
      const a = e.get(i.id), r = i.flowScale !== void 0;
      if (a.getBehavior(A)?._getResolvedData().measureGeometry !== !0) continue;
      const s = this._getProviders(a)[0];
      s instanceof q && n.push(s.watchBounds({
        intrinsic: r,
        epsilon: Ae
      }));
    }
    return n;
  }
  _getIntrinsicSize(t, e, n, i) {
    const a = e.get(t.id);
    if (!a) return t.layoutBox.size;
    const r = t.layoutBox.sizeMode.x === "Fixed" && t.layoutBox.size.x > 0 ? t.layoutBox.size.x : null;
    if (t.flowScale !== void 0) for (const s of this._getProviders(a)) {
      const d = s.getLayoutIntrinsicSize?.();
      if (d) return d;
    }
    for (const s of this._getProviders(a)) {
      if (s === this) continue;
      const d = this._fedWidthProviders.get(s)?.width, c = d != null && d > 0 ? d : r, l = c != null && s.getLayoutContentSizeForWidth ? s.getLayoutContentSizeForWidth(c) : s.getLayoutContentSize();
      if (l) return l;
    }
    if (t.childrenIds.length > 0 && i.has(t.id)) {
      const s = this._measureHeld(a, n, i);
      if (s)
        return this._heldCenters.set(t.id, s.center), s.size;
    }
    return this._heldCenters.delete(t.id), t.layoutBox.size;
  }
  _measureHeld(t, e, n) {
    const i = new m(1 / 0, 1 / 0, 1 / 0), a = new m(-1 / 0, -1 / 0, -1 / 0), r = (d, c) => {
      const l = m.TransformCoordinates(d, c);
      i.minimizeInPlace(l), a.maximizeInPlace(l);
    }, s = (d, c) => {
      for (const l of d.getChildren()) {
        const h = e.getNode(String(l.transform.uniqueId));
        if (!h || h.layoutItem?.positionMode === "Absolute") continue;
        const y = this._boxOf(l, h, n), C = l.transform, z = re(C);
        if (!y) {
          s(l, P.Compose(C.scaling, z, C.position).multiply(c));
          continue;
        }
        const S = (M) => M.multiply(y.scale).applyRotationQuaternion(z), I = C.position.add(y.centerFrame === "node" ? S(y.center) : y.center);
        for (const M of [-0.5, 0.5]) for (const D of [-0.5, 0.5]) for (const b of [-0.5, 0.5]) {
          const F = new m(M * y.size.x, D * y.size.y, b * y.size.z);
          r(I.add(y.sizeFrame === "node" ? S(F) : F), c);
        }
      }
    };
    return s(t, P.Identity()), i.x > a.x ? null : {
      size: {
        x: a.x - i.x,
        y: a.y - i.y,
        z: a.z - i.z
      },
      center: {
        x: (i.x + a.x) / 2,
        y: (i.y + a.y) / 2,
        z: (i.z + a.z) / 2
      }
    };
  }
  _boxOf(t, e, n) {
    const i = n.has(e.id), a = this._getProviders(t);
    for (const s of a) {
      const d = s.getLayoutContentSize();
      if (!d) continue;
      let c = m.Zero(), l = "node";
      for (const h of a) {
        const y = h.getLayoutContentCenter?.() ?? null;
        if (y) {
          c = new m(y.x, y.y, y.z ?? 0), l = h.layoutContentFrame ?? "node";
          break;
        }
      }
      return {
        size: d,
        sizeFrame: s.layoutContentFrame ?? "node",
        center: c,
        centerFrame: l,
        scale: i ? m.One() : t.transform.scaling.clone()
      };
    }
    if (!i) return null;
    const r = this._heldCenters.get(e.id);
    return {
      size: e.layoutBox.size,
      sizeFrame: "node",
      center: r ? new m(r.x, r.y, r.z) : m.Zero(),
      centerFrame: "node",
      scale: m.One()
    };
  }
  _heldCenterOf(t, e, n) {
    const i = this._heldCenters.get(t.id);
    if (!i) return null;
    const a = t.layoutBox.sizeMode, r = new m(a.x === "Hug" ? i.x : 0, a.y === "Hug" ? i.y : 0, a.z === "Hug" ? i.z : 0).scale(n).applyRotationQuaternion(re(e.transform));
    return {
      x: r.x,
      y: r.y,
      z: r.z
    };
  }
  _ownsDeparture(t) {
    const e = A.nearestLayoutAuthority(t);
    return e === null ? !0 : e._findLayoutRoot() === this.sceneObject;
  }
  _findLayoutRoot() {
    let t = this.sceneObject, e = t.getParent();
    for (; e; )
      e.getBehavior(f) && (t = e), e = e.getParent();
    return t;
  }
  _buildTree(t, e, n, i, a, r) {
    const s = t.getBehavior(f);
    if (s && s !== this && (s._managedFields.size > 0 || s._fedReceivers.size > 0 || s._fedWidthProviders.size > 0 || s._flowedAsAuto.size > 0) && s._releaseAll(), !s && n === null) return;
    const d = t.transform.uniqueId.toString();
    let c;
    if (s) {
      let l = !1;
      for (const y of t.getChildren()) this._isWaitingOn(y) && (l = !0);
      l && r.add(d), a.add(d), c = this._dataToLayoutNode(d, s._getResolvedData());
      const h = f._contentFitFor(t, c);
      h && (c.layoutContainer.contentFit = h);
    } else {
      const l = t.getBehavior(A);
      if (l)
        a.add(d), c = this._itemDataToLayoutNode(d, l._getResolvedData());
      else {
        c = X(d);
        const h = t.transform.scaling;
        c.layoutBox.size = {
          x: Math.abs(h.x),
          y: Math.abs(h.y),
          z: Math.abs(h.z)
        }, c.layoutBox.sizeMode = {
          x: "Fixed",
          y: "Fixed",
          z: "Fixed"
        }, c.layoutItem = ae(), c.layoutItem.mainAxisMode = "Fixed";
      }
    }
    (n !== null ? e.getNode(n) : void 0)?.layoutContainer?.contentFit && c.layoutItem?.positionMode !== "Absolute" && (c.flowScale = 1), e.addNode(c, n ?? void 0), i.set(d, t);
    for (const l of t.getChildren()) this._buildTree(l, e, d, i, a, r);
  }
  static _contentFitFor(t, e) {
    if (e.layoutContainer?.wrap === !0) return;
    let n = null;
    for (const r of t.getBehaviors()) if (le(r)) {
      n = r;
      break;
    }
    if (!n) return;
    const i = t.getChildren().filter((r) => (r.getBehavior(A)?._getResolvedData() ?? r.getBehavior(f)?._getResolvedData())?.positionMode !== "Absolute");
    if (i.length !== 1) return;
    const a = i[0];
    if (!a.getBehavior(f) && !a.getBehavior(A)) {
      !a.isLoadingBehaviors && !de.has(a) && (de.add(a), R.warn(`[Layout] The ContentSlot on "${t.name}" does not fit "${a.name}": it has neither a Layout nor a LayoutItem, so its box is its current scale and there is nothing to fit. Give it a LayoutItem (Hug).`));
      return;
    }
    return n.layoutContentFit;
  }
  _waitingSince = /* @__PURE__ */ new Map();
  _departureWatched = /* @__PURE__ */ new Set();
  _patienceTimer = null;
  _nextDeadline = 1 / 0;
  _isWaitingOn(t) {
    const e = t.transform.uniqueId;
    if (!t.isLoadingBehaviors)
      return this._waitingSince.delete(e), !1;
    const n = this._waitingSince.get(e) ?? Date.now();
    this._waitingSince.set(e, n);
    const i = n + oe;
    return Date.now() >= i ? !1 : (this._nextDeadline = Math.min(this._nextDeadline, i), this._departureWatched.has(e) || (this._departureWatched.add(e), t.transform.onDisposeObservable.addOnce(() => {
      this._departureWatched.delete(e), this._waitingSince.delete(e), this.sceneObject.transform.isDisposed() || this.invalidate();
    })), !0);
  }
  _armPatience() {
    if (this._patienceTimer !== null && (clearTimeout(this._patienceTimer), this._patienceTimer = null), this._nextDeadline === 1 / 0) return;
    const t = Math.max(0, this._nextDeadline - Date.now());
    this._patienceTimer = setTimeout(() => {
      this._patienceTimer = null, !this.sceneObject.transform.isDisposed() && (R.warn(`[Layout] "${this.sceneObject.name}" waited ${oe / 1e3}s for a child to finish building — arranging without it; it will join when it arrives.`), this.invalidate());
    }, t);
  }
  static _reparentHooked = /* @__PURE__ */ new WeakSet();
  static _installReparentHook(t) {
    !t || typeof t.onObjectReparented != "function" || f._reparentHooked.has(t) || (f._reparentHooked.add(t), t.onObjectReparented((e, n) => {
      e.isLoadingBehaviors && (n && !n.transform.isDisposed() && K(n), e.transform.isDisposed() || K(e));
    }), t.onBehaviorsLoaded?.((e) => {
      e.transform.isDisposed() || K(e);
    }));
  }
  _collectDeferred(t, e) {
    if (e.size === 0) return e;
    const n = /* @__PURE__ */ new Set(), i = (s) => s.layoutBox.sizeMode.x === "Fixed" && s.layoutBox.sizeMode.y === "Fixed" && s.layoutBox.sizeMode.z === "Fixed";
    for (const s of e) {
      let d = t.getNode(s);
      for (; d && !n.has(d.id); ) {
        n.add(d.id);
        const c = d.parentId ? t.getNode(d.parentId) : void 0;
        if (!c?.layoutContainer || d.layoutItem?.positionMode === "Absolute" || i(d)) break;
        d = c;
      }
    }
    const a = /* @__PURE__ */ new Set(), r = (s) => {
      if (!a.has(s.id)) {
        a.add(s.id);
        for (const d of t.getChildren(s.id))
          i(d) || (n.add(d.id), r(d));
      }
    };
    for (const s of [...n]) {
      const d = t.getNode(s);
      d && r(d);
    }
    return n;
  }
  _dataToLayoutNode(t, e) {
    const n = this._applyItemFields(X(t), e);
    return n.layoutContainer = ze(), n.layoutContainer.directionAxis = e.direction ?? "Y", n.layoutContainer.gap = e.gap ?? 0.02, n.layoutContainer.alignMain = e.alignMain ?? "Start", n.layoutContainer.alignCrossA = e.alignCross ?? "Start", n.layoutContainer.alignCrossB = e.alignCrossB ?? "Center", n.layoutContainer.alignContentCrossA = e.alignContent ?? "Start", n.layoutContainer.alignContentCrossB = e.alignContentCrossB ?? "Start", n.layoutContainer.crossGap = e.crossGap, typeof e.padding == "number" ? n.layoutContainer.padding = ie(e.padding) : e.padding ? n.layoutContainer.padding = {
      left: e.padding.left ?? 0,
      right: e.padding.right ?? 0,
      top: e.padding.top ?? 0,
      bottom: e.padding.bottom ?? 0,
      front: e.padding.front ?? 0,
      back: e.padding.back ?? 0
    } : n.layoutContainer.padding = ie(0.02), e.wrap != null && (n.layoutContainer.wrap = e.wrap), e.wrap && e.wrapAxis && e.wrapAxis !== (e.direction ?? "Y") && (n.layoutContainer.wrapAxis = e.wrapAxis), n;
  }
  _itemDataToLayoutNode(t, e) {
    return this._applyItemFields(X(t), e);
  }
  _applyItemFields(t, e) {
    const n = e.widthMode ?? "Fixed", i = e.heightMode ?? "Fixed", a = e.depthMode ?? "Fixed", r = (h, y) => y ?? (h === "Fill" ? 0 : we);
    t.layoutBox.size = {
      x: r(n, e.width),
      y: r(i, e.height),
      z: r(a, e.depth)
    }, t.layoutBox.sizeMode = {
      x: n,
      y: i,
      z: a
    }, t.layoutBox.sizeIsBasisX = n === "Fill", t.layoutBox.sizeIsBasisY = i === "Fill", t.layoutBox.sizeIsBasisZ = a === "Fill";
    const s = e.minWidth ?? 0, d = e.minHeight ?? 0, c = e.minDepth ?? 0;
    t.layoutBox.min = {
      x: s,
      y: d,
      z: c
    }, t.layoutBox.max = {
      x: Math.max(s, e.maxWidth ?? 1 / 0),
      y: Math.max(d, e.maxHeight ?? 1 / 0),
      z: Math.max(c, e.maxDepth ?? 1 / 0)
    }, t.layoutBox.minExplicitX = e.minWidth != null, t.layoutBox.minExplicitY = e.minHeight != null, t.layoutBox.minExplicitZ = e.minDepth != null, t.layoutItem = ae(), t.layoutItem.mainAxisMode = "Fixed";
    const l = e.flexGrow ?? 0;
    return t.layoutItem.flexGrow = l > 0 ? l : void 0, t.layoutItem.flexShrink = e.flexShrink ?? 1, t.layoutItem.positionMode = e.positionMode ?? "Auto", t.layoutItem.inset = e.inset, t.layoutItem.alignSelfCross = e.alignSelfCross, t.layoutItem.alignSelfCrossB = e.alignSelfCrossB, t;
  }
  _xIsImposedByParent(t, e) {
    const n = t.layoutContainer;
    if (!n || e.flowScale !== void 0) return !1;
    const i = e.layoutItem, a = i?.widthPercent;
    if (typeof a == "number" && Number.isFinite(a) || e.layoutBox.sizeMode.x === "Fill") return !0;
    if (i?.positionMode === "Absolute") return !1;
    const [r, s] = Fe(n);
    return (r === "X" ? i?.alignSelfCross ?? n.alignCrossA : s === "X" ? i?.alignSelfCrossB ?? n.alignCrossB : void 0) === "Stretch" && e.layoutBox.sizeMode.x !== "Fixed";
  }
  _findAncestorWrapWidth(t, e, n) {
    let i = e, a = n, r = 0;
    for (; a; ) {
      if (!this._xIsImposedByParent(a, i)) return null;
      const s = a.layoutContainer ? a.layoutContainer.padding.left + a.layoutContainer.padding.right : 0;
      if (!(a.layoutBox.sizeMode.x === "Hug" && Math.abs(a.resolvedSize.x - a.layoutBox.size.x) <= 1e-6)) {
        const d = a.resolvedSize.x - s - r;
        return d > 1e-6 ? d : null;
      }
      r += s, i = a, a = a.parentId ? t.getNode(a.parentId) : void 0;
    }
    return null;
  }
  _carryForward(t, e, n, i, a) {
    for (const c of t.getBehaviors())
      if ($(c)) {
        this._fedReceivers.has(c) && e.add(c);
        break;
      }
    for (const c of this._getProviders(t)) {
      const l = this._fedWidthProviders.get(c);
      l?.owner === t && n.set(c, l);
    }
    const r = t.transform.uniqueId, s = this._flowedAsAuto.get(r);
    s && i.set(r, s);
    const d = this._managedFields.get(t);
    d && a.set(t, d);
  }
  _applyResults(t, e, n, i) {
    if (t.getRoots().length === 0) return;
    const a = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), d = f._observedScenes.has(this.sceneObject.traceScene) ? /* @__PURE__ */ new Map() : null, c = /* @__PURE__ */ new Map();
    t.traverse((l) => {
      const h = e.get(l.id);
      if (!h) return;
      if (l.parentId && i.has(l.parentId)) {
        this._carryForward(h, a, r, s, c);
        return;
      }
      const y = n.has(l.id), C = this._getProviders(h), z = C[0] ?? null;
      let S = null;
      for (const p of h.getBehaviors()) if ($(p)) {
        S = p;
        break;
      }
      if (!l.parentId) return;
      const I = t.getNode(l.parentId);
      if (!I) return;
      const M = !!I.layoutContainer, D = l.resolvedPosition, b = l.resolvedSize, F = I.resolvedSize, te = l.childrenIds.length === 0, E = z?.layoutFit;
      let W = !1, j;
      const k = l.flowScale;
      if (k !== void 0) {
        const p = te && !z && !S ? new m((b.x || T) * k, (b.y || T) * k, (b.z || T) * k) : new m(k, k, k);
        j = [
          p.x,
          p.y,
          p.z
        ];
        const u = h.transform.scaling;
        (Math.abs(u.x - p.x) > 1e-6 || Math.abs(u.y - p.y) > 1e-6 || Math.abs(u.z - p.z) > 1e-6) && h.setScale(p, null);
      } else if (y && te && !S && E && E !== "none") {
        const p = z?.getLayoutIntrinsicSize?.() ?? null, u = p ? Ee(E, p, l.resolvedSize, l.layoutBox.sizeMode, l.layoutBox.size) : null;
        if (u) {
          j = [
            u.x,
            u.y,
            u.z
          ];
          const g = h.transform.scaling;
          (Math.abs(g.x - u.x) > 1e-6 || Math.abs(g.y - u.y) > 1e-6 || Math.abs(g.z - u.z) > 1e-6) && (h.setScale(new m(u.x, u.y, u.z), null), this._scheduleBatch()), W = !0;
        }
      }
      const V = l.layoutItem?.positionMode === "Absolute", Y = V && l.layoutItem?.inset != null, L = h.transform.uniqueId;
      if (V && !Y && M && this._flowedAsAuto.has(L)) {
        const p = this._flowedAsAuto.get(L) ?? [
          0,
          0,
          0
        ], u = h.transform.position;
        (u.x !== p[0] || u.y !== p[1] || u.z !== p[2]) && h.setPosition(new m(p[0], p[1], p[2]), null), U(h, { position: p });
      }
      if ((!V || Y) && M) {
        const p = Y ? this._flowedAsAuto.get(L)?.[2] ?? h.getSceneObjectData().transform?.translation?.[2] ?? 0 : null, u = k !== void 0 ? {
          x: b.x * k,
          y: b.y * k,
          z: b.z * k
        } : b, g = new m(D.x - F.x / 2 + u.x / 2, F.y / 2 - D.y - u.y / 2, p ?? D.z - F.z / 2 + u.z / 2), H = d ? {
          x: g.x,
          y: g.y,
          z: g.z
        } : null;
        let x = null;
        for (const B of C)
          if (x = B.getLayoutContentCenter?.() ?? null, x) break;
        if (x ??= this._heldCenterOf(l, h, k ?? 1), x && (g.x -= x.x, g.y -= x.y, x.z != null && (g.z -= x.z)), W && z?.layoutFitAnchor === "bottom") {
          const B = z.getLayoutContentSize(), N = B ? b.y - B.y : 0;
          N > 1e-6 && (g.y -= N / 2);
        }
        s.set(L, this._flowedAsAuto.get(L) ?? h.getSceneObjectData().transform?.translation ?? [
          0,
          0,
          0
        ]), d && H && He(d, h, e.get(l.parentId), F, H, u, g), h.setPosition(g, null), U(h, { position: [
          g.x,
          g.y,
          g.z
        ] }), c.set(h, {
          position: !0,
          scale: !1
        });
      }
      const ne = l.childrenIds.length > 0;
      if (y) {
        S && (S.setResolvedSize({
          x: b.x,
          y: b.y,
          z: b.z
        }), a.add(S));
        const p = l.layoutBox.sizeMode.x === "Hug" && Math.abs(b.x - l.layoutBox.size.x) <= 1e-6 ? this._findAncestorWrapWidth(t, l, I) : b.x, u = l.layoutBox.sizeMode.x === "Hug" ? A.hugCeiling(l.layoutBox.max.x) : null, g = u != null ? Math.min(u, p ?? u) : p, H = p == null ? null : g;
        for (const v of C)
          v.setLayoutResolvedWidth && (v.setLayoutResolvedWidth(g, H), r.set(v, {
            owner: h,
            width: g
          }));
        const x = (!ne || z instanceof q) && !S && !!E && !W, B = h.getRuntimeOwnedTransformFields().scale, N = h.getBehaviors().some(le);
        let _ = !1;
        if (k !== void 0) _ = !0;
        else if (!ne && !z && !S && !N) {
          const v = new m(b.x || T, b.y || T, b.z || T);
          h.setScale(v, null), _ = !0;
        } else if (W) _ = !0;
        else if (!x || B) {
          const v = h.transform.scaling;
          (v.x !== 1 || v.y !== 1 || v.z !== 1) && h.setScale(new m(1, 1, 1), null), _ = !x, x && U(h, { scale: [
            1,
            1,
            1
          ] });
        }
        if (_) {
          const v = c.get(h) ?? {
            position: !1,
            scale: !1
          };
          v.scale = !0, j && (v.fitted = !0), c.set(h, v);
        }
        if (_) {
          const v = h.transform.scaling;
          U(h, { scale: j ?? [
            v.x,
            v.y,
            v.z
          ] });
        }
      }
    });
    for (const l of this._fedReceivers) a.has(l) || l.clearResolvedSize?.();
    this._fedReceivers = a;
    for (const [l, { owner: h }] of this._fedWidthProviders)
      r.has(l) || h.transform.isDisposed() || this._ownsDeparture(h) && A.feedStandaloneWidth(h, !0);
    this._fedWidthProviders = r, this._flowedAsAuto = s, this._solvedPlacements = d;
    for (const [l, h] of c) l.setRuntimeTransformFieldOwner(this, {
      position: h.position,
      scale: h.scale
    });
    for (const l of this._managedFields.keys()) c.has(l) || l.setRuntimeTransformFieldOwner(this, {
      position: !1,
      scale: !1
    });
    this._managedFields = c, this._applyStackingOrder(t, e);
  }
  _applyStackingOrder(t, e) {
    let n = 0;
    t.traverse((i) => {
      const a = n++, r = e.get(i.id);
      if (!r) return;
      const s = r.transform, d = typeof s.getBoundingInfo == "function" ? [r.transform] : s.getChildMeshes(!0);
      for (const c of d) c.alphaIndex = a;
    });
  }
};
function U(o, t) {
  const { position: e, scale: n } = t;
  if (!o.traceScene.isPlayMode()) {
    o._getTransformData() || o.captureTransform();
    const i = o._getTransformData();
    i && e && (i.translation = [
      e[0],
      e[1],
      e[2]
    ]), i && n && (i.scale = [
      n[0],
      n[1],
      n[2]
    ]);
  }
  o.getBehavior(Se)?.setRestPose({
    position: e && new m(e[0], e[1], e[2]),
    scale: n && new m(n[0], n[1], n[2])
  });
}
function K(o) {
  let t = o;
  for (; t; ) {
    const e = t.getBehavior(ke);
    if (e) {
      e.invalidate();
      return;
    }
    t = t.getParent();
  }
  queueMicrotask(() => {
    o.transform.isDisposed() || A.feedStandaloneWidth(o);
  });
}
function ft(o) {
  if (xe(o.src) || typeof o.src == "string" && ee(o.src)) return;
  const t = o._getBehaviorData();
  if (!t?.some((s) => s["@type"] === "Model")) return;
  const e = t.find((s) => s["@type"] === "LayoutItem" || s["@type"] === "Layout");
  if (!e) return;
  const n = e, i = o.transform.scaling;
  if (i.x === 1 && i.y === 1 && i.z === 1) return;
  const a = [
    {
      scale: i.x,
      mode: n.widthMode ?? "Fixed",
      authored: n.width
    },
    {
      scale: i.y,
      mode: n.heightMode ?? "Fixed",
      authored: n.height
    },
    {
      scale: i.z,
      mode: n.depthMode ?? "Fixed",
      authored: n.depth
    }
  ];
  for (const s of a)
    if (!(Math.abs(s.scale - T) < 1e-6) && (s.mode === "Fill" || s.authored != null && typeof s.authored != "number" || Math.abs(s.scale - (typeof s.authored == "number" ? s.authored : we)) >= 1e-6))
      return;
  o.transform.scaling.set(1, 1, 1);
  const r = o._getTransformData();
  r?.scale && (r.scale = [
    1,
    1,
    1
  ]);
}
export {
  rt as C,
  st as D,
  Be as E,
  _e as S,
  fe as T,
  be as _,
  ft as a,
  mt as b,
  De as c,
  pt as d,
  dt as f,
  lt as g,
  ct as h,
  $ as i,
  O as l,
  ht as m,
  K as n,
  oe as o,
  ut as p,
  We as r,
  A as s,
  ke as t,
  Pe as u,
  ee as v,
  Re as w,
  Oe as x,
  ge as y
};

//# sourceMappingURL=layout-BD1t4ofR.js.map